  import React from "react";
  import api from "@/lib/api";
  import ReactMarkdown from "react-markdown";
  import DOMPurify from "dompurify";
  import remarkGfm from "remark-gfm";
  import {
    X, Gear, Star, Trash, Lightning, Calendar,
    ToggleLeft, ToggleRight, WarningCircle, Sparkle,
    CheckCircle, PaperPlaneRight, Robot, User as UserIcon, Paperclip,Plus, CaretDown,
  } from "@phosphor-icons/react";
  import { useErp } from "@/context/ErpContext";
  import WizardFields from "@/components/erp/WizardFields";
  import RFPAgentModal from "@/components/erp/RFPAgentModal";
  import InvoiceAgeingModal from "@/components/erp/InvoiceAgeingModal"
  import SupplierAgeingModal from "@/components/erp/SupplierAgeingModal";
  // TASK 3 — Supplier-specific modal (isolated, does not affect other agents)

  import ConfirmReviewPopup from "@/components/erp/ConfirmReviewPopup";

  const DOW = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const CHAT_ONLY_PATTERNS = [
    "account-overview",
    "account_overview",
    "finance-variance",
    "finance-account-variance",
    "finance-future",
    "future-insight",
    "finance-narrative",
    "finance-reporting-narrative",
  ];
  function buildFieldContext(fieldValues, schemaFields) {
    if (!schemaFields?.length) return "";
    return schemaFields
      .map((f) => {
        const raw = fieldValues[f.name];
        if (!raw) return null;
        if (f.type === "date") return `${f.label}: ${formatDateForContext(raw)}`;
        const label = fieldValues[`${f.name}__label`];
        return `${f.label}: ${label || raw}`;
      })
      .filter(Boolean)
      .join(", ");
  }

  function isChatOnlyAgent(key) {
    if (!key) return false;
    return CHAT_ONLY_PATTERNS.some((p) => key.includes(p));
  }

  function timeUntil(iso) {
    if (!iso) return "—";
    const ms = new Date(iso).getTime() - Date.now();
    if (ms <= 0) return "due now";
    const m = Math.floor(ms / 60000);
    if (m < 60) return `in ${m}m`;
    const h = Math.floor(m / 60);
    if (h < 48) return `in ${h}h ${m % 60}m`;
    return `in ${Math.floor(h / 24)}d`;
  }

  function describeSchedule(s) {
    const hh = String(s.hour_utc).padStart(2, "0");
    if (s.cadence === "daily") return `Daily · ${hh}:00 UTC`;
    if (s.cadence === "weekly") return `Weekly · ${DOW[s.day_of_week] || "Mon"} · ${hh}:00 UTC`;
    return `Monthly · day ${s.day_of_month} · ${hh}:00 UTC`;
  }

  /* ── Receipt attachment upload ── */
  // function ReceiptAttachmentUpload({ fieldUi, onUploaded }) {
  //   const fileInputRef = React.useRef(null);
  //   const [uploading, setUploading] = React.useState(false);
  //   const [uploadStatus, setUploadStatus] = React.useState(null);

  //   const handleFile = async (e) => {
  //     const file = e.target.files?.[0];
  //     if (!file) return;
  //     e.target.value = '';
  //     setUploading(true);
  //     setUploadStatus(null);
  //     try {
  //       const sid = window.__receiptSessionId;
  //       if (!sid) { setUploadStatus({ ok: false, text: 'No active session — start chat first.' }); return; }
  //       const formData = new FormData();
  //       formData.append('file', file);
  //       const res = await api.post(
  //         `/erp-agents/receipt-create/${sid}/upload-receipt-attachment`,
  //         formData,
  //         { headers: { 'Content-Type': 'multipart/form-data' } }
  //       );
  //       const extraction = res.data?.extraction || {};
  //       if (extraction.success) {
  //         setUploadStatus({ ok: true, text: `Extracted: ${extraction.receipt_number} (${extraction.confidence} confidence)` });
  //       } else {
  //         setUploadStatus({ ok: false, text: extraction.error || 'Could not extract — enter manually.' });
  //       }
  //       if (onUploaded) onUploaded({ value: '__ATTACHMENT_UPLOADED__', label: file.name });
  //     } catch (err) {
  //       setUploadStatus({ ok: false, text: err?.response?.data?.detail || err.message || 'Upload failed' });
  //     } finally {
  //       setUploading(false);
  //     }
  //   };

  //   return (
  //     <div className="mt-2 border border-[#0020C2]/20 rounded-lg overflow-hidden bg-white" data-testid="chat-receipt-attachment">
  //       <div className="px-3 py-2 text-xs text-gray-600 bg-gray-50 border-b border-gray-100 font-medium">
  //         Upload receipt document to extract Receipt Number automatically
  //       </div>
  //       {uploadStatus && (
  //         <div className={`px-3 py-1.5 text-xs ${uploadStatus.ok ? 'text-emerald-700 bg-emerald-50' : 'text-red-700 bg-red-50'}`}>
  //           {uploadStatus.ok ? '[OK] ' : '[ERR] '}{uploadStatus.text}
  //         </div>
  //       )}
  //       <div className="flex">
  //         <input ref={fileInputRef} type="file"
  //           accept={fieldUi?.accept || '.pdf,.png,.jpg,.jpeg,.docx,.xlsx'}
  //                     className="hidden" onChange={handleFile} />
  //         <button onClick={() => fileInputRef.current?.click()} disabled={uploading}
  //           className="flex-1 text-xs font-bold px-3 py-2 bg-[#0020C2] text-white hover:bg-[#001AA3] disabled:opacity-50 transition-colors flex items-center justify-center gap-1.5">
  //           {uploading ? 'Uploading...' : (fieldUi?.label || 'Upload Receipt Document')}

  //         </button>
  //       </div>
  //       <div className="px-3 py-1.5 text-[10px] text-gray-400">Supported: PDF, PNG, JPEG, DOCX, XLSX (max 20 MB)</div>
  //     </div>
  //   );
  // }

  /* ── Chat bubble ─────────────────────────────────────────────────────────── */
  function MultiSelectChatOptions({ fieldUi, onSubmit }) {
    const [selected, setSelected] = React.useState([]);
    const options = fieldUi.options || [];
    const allowSkip = fieldUi.field === "__classification__";

    const toggle = (value) => {
      setSelected((prev) => prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]);
    };

    return (
      <div className="mt-2 border border-[#0020C2]/20 rounded-lg overflow-hidden bg-white" data-testid={`chat-field-ui-${fieldUi.field}`}>
        <div className="max-h-48 overflow-y-auto divide-y divide-gray-50">
          {options.length === 0 && (
            <div className="px-3 py-2 text-xs text-gray-400">No options available.</div>
          )}
          {options.map((opt) => {
            const checked = selected.includes(opt.value);
            return (
              <label
                key={opt.value}
                className="flex items-center gap-2 px-3 py-2 text-xs hover:bg-[#0020C2]/5 cursor-pointer"
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => toggle(opt.value)}
                  className="accent-[#0020C2] w-3.5 h-3.5"
                />
                <span className={checked ? "text-[#0020C2] font-medium" : "text-gray-700"}>{opt.label}</span>
              </label>
            );
          })}
        </div>
        <div className="flex">
          <button
            onClick={() => selected.length && onSubmit(selected)}
            disabled={selected.length === 0}
            data-testid="multi-select-submit"
            className="flex-1 text-xs font-bold px-3 py-2 bg-[#0020C2] text-white disabled:bg-gray-200 disabled:text-gray-400 transition-colors"
          >
            {selected.length ? `Select ${selected.length} item${selected.length > 1 ? "s" : ""}` : "Select above"}
          </button>
          {allowSkip && (
            <button
              onClick={() => onSubmit(["none"])}
              data-testid="multi-select-skip"
              className="text-xs font-bold px-3 py-2 bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors border-l border-gray-200"
            >
              None
            </button>
          )}
        </div>
      </div>
    );
  }

  function SearchableChatOptions({ fieldUi, onPick }) {
    const [q, setQ] = React.useState("");
    const options = fieldUi.options || [];
    const filtered = q ? options.filter((o) => o.label.toLowerCase().includes(q.toLowerCase())) : options;
    return (
      <div className="mt-2 border border-[#0020C2]/20 rounded-lg overflow-hidden bg-white" data-testid={`chat-field-ui-${fieldUi.field}`}>
        <input
          autoFocus
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder={`Search ${fieldUi.field.replace(/_/g, " ")}…`}
          className="w-full px-3 py-2 text-xs outline-none border-b border-gray-100"
        />
        <div className="max-h-40 overflow-y-auto">
          {options.length === 0 && (
            <div className="px-3 py-2 text-xs text-gray-400">No options available right now.</div>
          )}
          {options.length > 0 && filtered.length === 0 && (
            <div className="px-3 py-2 text-xs text-gray-400">No matches</div>
          )}
          {filtered.slice(0, 50).map((opt) => (
            <div
              key={opt.value}
              onClick={() => onPick(opt)}
              className="px-3 py-1.5 text-xs hover:bg-[#0020C2]/5 cursor-pointer border-b border-gray-50 last:border-0"
            >
              {opt.label}
            </div>
          ))}
        </div>
      </div>
    );
  }

  /* ── Editable GL + Site recommendations widget (UPGRADED) ─────────────────────
    REPLACES the existing EditableRecommendations component in AgentRunModal.jsx.

    Rendered when the backend returns next_field_ui.uiType ===
    "editable_recommendations". The backend now also sends supplier_name (and
    supplier_number) so this widget can query the GL and site LOVs for that
    supplier.

    GL Account  -> searchable picker over the supplier's HISTORICAL GL
                    combinations (type e.g. "electronic" to filter by the line
                    description). If the search finds nothing, the agent's
                    recommended GL is kept (pre-filled, still editable by hand).
    Supplier Site -> dropdown of the supplier's active sites; the recommended
                    site is pre-selected. Falls back to a free text box if the
                    site list can't be loaded.

    On confirm it serializes to the SAME message the backend already parses:
        RECOMMENDATIONS: gl=<combo>; site=<site>
    so no backend graph / set_recommendations change is needed.

    Requires (already imported in AgentRunModal.jsx): React, api, Sparkle,
    CaretDown, CheckCircle.                                                     */
  function EditableRecommendations({ fieldUi, onSubmit }) {
    const supplier = fieldUi.supplier_name || "";

    const [gl, setGl] = React.useState(fieldUi.gl_account || "");
    const [site, setSite] = React.useState(fieldUi.supplier_site || "");

    // ── GL picker state ──
    const [glOpen, setGlOpen] = React.useState(false);
    const [glQuery, setGlQuery] = React.useState("");
    const [glItems, setGlItems] = React.useState([]);
    const [glLoading, setGlLoading] = React.useState(false);
    const [glManual, setGlManual] = React.useState(false);   // user typed a custom GL
    const glDebounce = React.useRef(null);
    const glReq = React.useRef(0);

    // ── Site dropdown state ──
    const [sites, setSites] = React.useState([]);
    const [siteIdx, setSiteIdx] = React.useState(-1);   // selected row (-1 = recommended)
    const [sitesLoading, setSitesLoading] = React.useState(false);
    const [sitesFailed, setSitesFailed] = React.useState(false);

    // Load the supplier's sites once (recommended stays preselected).
    React.useEffect(() => {
      if (!supplier) { setSitesFailed(true); return; }
      let alive = true;
      setSitesLoading(true);
      api.get("/erp-agents/invoice-create/site-lov", { params: { supplier } })
        .then(({ data }) => {
          if (!alive) return;
          const items = data?.items || [];
          setSites(items);
          // Preselect the first row matching the recommended site code; else the
          // recommended fallback row (-1).
          const rec = fieldUi.supplier_site || "";
          const match = items.findIndex((s) => s.site === rec);
          setSiteIdx(match);
          if (match >= 0) setSite(items[match].site);
          // If the recommended site isn't in the list, keep it anyway (as a value).
          if (items.length === 0) setSitesFailed(true);
        })
        .catch(() => { if (alive) setSitesFailed(true); })
        .finally(() => { if (alive) setSitesLoading(false); });
      return () => { alive = false; };
    }, [supplier]);

    // GL search — debounced. Empty query loads all historical combos.
    const fetchGl = React.useCallback((q) => {
      if (!supplier) return;
      const myReq = ++glReq.current;
      setGlLoading(true);
      api.get("/erp-agents/invoice-create/gl-lov", { params: { supplier, search: q } })
        .then(({ data }) => {
          if (myReq !== glReq.current) return;
          setGlItems(data?.items || []);
        })
        .catch(() => { if (myReq === glReq.current) setGlItems([]); })
        .finally(() => { if (myReq === glReq.current) setGlLoading(false); });
    }, [supplier]);

    React.useEffect(() => {
      if (!glOpen) return;
      if (glDebounce.current) clearTimeout(glDebounce.current);
      glDebounce.current = setTimeout(() => fetchGl(glQuery.trim()), 300);
      return () => clearTimeout(glDebounce.current);
    }, [glQuery, glOpen, fetchGl]);

    const pickGl = (item) => {
      setGl(item.gl);
      setGlManual(false);
      setGlOpen(false);
      setGlQuery("");
    };

    return (
      <div className="mt-2 border border-[#0020C2]/20 rounded-xl bg-white p-3 space-y-3"
        data-testid="chat-editable-recommendations">
        <div className="text-[10px] font-bold uppercase tracking-wider text-[#0020C2] flex items-center gap-1">
          <Sparkle size={10} weight="fill" /> Recommended — edit if needed
        </div>

        {/* ── GL Account: searchable historical picker ── */}
        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-gray-500">
            GL Account
          </label>

          {/* Selected value + toggle */}
          <div className="flex items-center gap-1.5">
            <input
              value={gl}
              onChange={(e) => { setGl(e.target.value); setGlManual(true); }}
              placeholder="GL combination"
              className="flex-1 px-3 py-2 text-xs font-mono border border-gray-300 rounded-lg
                focus:outline-none focus:border-[#0020C2]"
            />
            <button
              type="button"
              onClick={() => { setGlOpen((v) => !v); if (!glOpen && glItems.length === 0) fetchGl(""); }}
              className="shrink-0 px-2 py-2 text-[10px] font-bold uppercase tracking-wider
                border border-[#0020C2]/30 text-[#0020C2] rounded-lg hover:bg-[#0020C2]/5
                flex items-center gap-1">
              Browse <CaretDown size={10} weight="bold" className={glOpen ? "rotate-180" : ""} />
            </button>
          </div>

          {glOpen && (
            <div className="border border-[#0020C2]/20 rounded-lg overflow-hidden">
              <input
                autoFocus
                value={glQuery}
                onChange={(e) => setGlQuery(e.target.value)}
                placeholder='Search past GL by description — e.g. "electronic"'
                className="w-full px-3 py-2 text-xs outline-none border-b border-gray-100"
              />
              <div className="max-h-44 overflow-y-auto">
                {glLoading && (
                  <div className="px-3 py-2 text-[11px] text-gray-400 flex items-center gap-2">
                    <span className="w-3 h-3 border-2 border-gray-300 border-t-[#0020C2] rounded-full animate-spin" />
                    Loading…
                  </div>
                )}
                {!glLoading && glItems.length === 0 && (
                  <div className="px-3 py-2 text-[11px] text-gray-400">
                    {glQuery.trim()
                      ? `No past GL matches "${glQuery.trim()}". Keeping the recommended GL — you can also type one above.`
                      : "No historical GL combinations for this supplier. Keep the recommended GL, or type one above."}
                  </div>
                )}
                {!glLoading && glItems.map((it, i) => (
                  <button
                    type="button"
                    key={`${it.gl}-${i}`}
                    onClick={() => pickGl(it)}
                    className="w-full text-left px-3 py-1.5 hover:bg-[#0020C2]/5 border-b border-gray-50 last:border-0">
                    <div className="font-mono text-[11px] text-gray-900">{it.gl}</div>
                    <div className="text-[10px] text-gray-500 flex items-center justify-between gap-2">
                      <span className="truncate">{it.description || "—"}</span>
                      <span className="shrink-0 text-gray-400">
                        {it.use_count > 1 ? `used ${it.use_count}×` : ""}
                      </span>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          )}

          {fieldUi.gl_reason && !glOpen && (
            <p className="text-[10px] text-gray-500">
              {glManual ? "Custom GL entered." : fieldUi.gl_reason}
            </p>
          )}
        </div>

        {/* ── Supplier Site: dropdown of the supplier's sites ── */}
        <div className="space-y-1">
          <label className="text-[10px] font-bold uppercase tracking-wider text-gray-500">
            Supplier Site
          </label>

          {sitesLoading ? (
            <div className="px-3 py-2 text-[11px] text-gray-400 flex items-center gap-2 border border-gray-200 rounded-lg">
              <span className="w-3 h-3 border-2 border-gray-300 border-t-[#0020C2] rounded-full animate-spin" />
              Loading sites…
            </div>
          ) : sitesFailed || sites.length === 0 ? (
            // Fallback: free text (keeps the recommended site).
            <input
              value={site}
              onChange={(e) => setSite(e.target.value)}
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-lg
                focus:outline-none focus:border-[#0020C2]"
            />
          ) : (
            <select
              value={siteIdx}
              onChange={(e) => {
                const idx = parseInt(e.target.value, 10);
                setSiteIdx(idx);
                // idx -1 = the recommended fallback row; else pick from list.
                setSite(idx < 0 ? (fieldUi.supplier_site || "") : (sites[idx]?.site || ""));
              }}
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-lg bg-white
                focus:outline-none focus:border-[#0020C2]">
              {/* Recommended fallback row when it isn't already in the list */}
              {fieldUi.supplier_site && !sites.some((s) => s.site === fieldUi.supplier_site) && (
                <option value={-1}>{fieldUi.supplier_site} (recommended)</option>
              )}
              {sites.map((s, i) => (
                <option key={`${s.site}-${s.procurement_bu}-${i}`} value={i}>
                  {s.site}
                  {s.procurement_bu ? ` · ${s.procurement_bu}` : ""}
                  {s.pay_site ? " · pay" : ""}
                </option>
              ))}
            </select>
          )}

          {fieldUi.site_reason && (
            <p className="text-[10px] text-gray-500">{fieldUi.site_reason}</p>
          )}
        </div>

        <button
          onClick={() => onSubmit(`RECOMMENDATIONS: gl=${gl.trim()}; site=${site.trim()}`)}
          className="w-full bg-[#0020C2] text-white py-2 rounded-lg text-xs font-bold
            uppercase tracking-wider hover:bg-[#001AA3]">
          Confirm GL &amp; Site
        </button>
      </div>
    );
  }

  /* ── Line-items builder widget ───────────────────────────────────────────────
    Rendered when the backend returns next_field_ui.uiType ===
    "line_items_builder". Add/remove line rows (description, quantity, unit
    price), a single tax %, and a live subtotal/tax/total. On submit serializes
    to a message string the backend extractor parses:
      LINES: [{"description":..,"quantity":..,"unit_price":..}]; TAX: 5       */
  function LineItemsBuilder({ fieldUi, onSubmit }) {
    const currency = fieldUi.currency || "AED";
    const [rows, setRows] = React.useState([
      { description: "", quantity: "", unit_price: "" },
    ]);
    const [tax, setTax] = React.useState("");

    const updateRow = (i, key, val) => {
      setRows((prev) => prev.map((r, idx) => (idx === i ? { ...r, [key]: val } : r)));
    };
    const addRow = () =>
      setRows((prev) => [...prev, { description: "", quantity: "", unit_price: "" }]);
    const removeRow = (i) =>
      setRows((prev) => (prev.length === 1 ? prev : prev.filter((_, idx) => idx !== i)));

    const net = rows.reduce((sum, r) => {
      const q = parseFloat(r.quantity) || 0;
      const p = parseFloat(r.unit_price) || 0;
      return sum + q * p;
    }, 0);
    const taxPct = parseFloat(tax) || 0;
    const taxAmt = net * (taxPct / 100);
    const total = net + taxAmt;

    const canSubmit = rows.some(
      (r) => r.description.trim() && parseFloat(r.quantity) > 0
    );

    const submit = () => {
      const clean = rows
        .filter((r) => r.description.trim() && parseFloat(r.quantity) > 0)
        .map((r) => ({
          description: r.description.trim(),
          quantity: parseFloat(r.quantity) || 0,
          unit_price: parseFloat(r.unit_price) || 0,
        }));
      onSubmit(`LINES: ${JSON.stringify(clean)}; TAX: ${taxPct}`);
    };

    return (
      <div className="mt-2 border border-[#0020C2]/20 rounded-xl bg-white p-3 space-y-2"
        data-testid="chat-line-items-builder">
        <div className="text-[10px] font-bold uppercase tracking-wider text-[#0020C2] flex items-center gap-1">
          <Sparkle size={10} weight="fill" /> Invoice line items
        </div>

        {rows.map((r, i) => (
          <div key={i} className="flex gap-1.5 items-center">
            <input
              value={r.description}
              onChange={(e) => updateRow(i, "description", e.target.value)}
              placeholder="Product / description"
              className="flex-1 px-2 py-1.5 text-xs border border-gray-300 rounded
                focus:outline-none focus:border-[#0020C2]"
            />
            <input
              value={r.quantity}
              onChange={(e) => updateRow(i, "quantity", e.target.value)}
              placeholder="Qty"
              inputMode="decimal"
              className="w-14 px-2 py-1.5 text-xs border border-gray-300 rounded text-right
                focus:outline-none focus:border-[#0020C2]"
            />
            <input
              value={r.unit_price}
              onChange={(e) => updateRow(i, "unit_price", e.target.value)}
              placeholder="Price"
              inputMode="decimal"
              className="w-20 px-2 py-1.5 text-xs border border-gray-300 rounded text-right
                focus:outline-none focus:border-[#0020C2]"
            />
            <button
              onClick={() => removeRow(i)}
              className="text-[#DC2626] shrink-0 p-1 disabled:opacity-30"
              disabled={rows.length === 1}
              title="Remove line">
              <Trash size={12} weight="bold" />
            </button>
          </div>
        ))}

        <button
          onClick={addRow}
          className="text-[11px] font-bold text-[#0020C2] hover:underline flex items-center gap-1">
          + Add line
        </button>

        <div className="flex items-center gap-2 pt-1 border-t border-gray-100">
          <label className="text-[10px] font-bold uppercase tracking-wider text-gray-500">
            Tax %
          </label>
          <input
            value={tax}
            onChange={(e) => setTax(e.target.value)}
            placeholder="e.g. 5"
            inputMode="decimal"
            className="w-16 px-2 py-1.5 text-xs border border-gray-300 rounded text-right
              focus:outline-none focus:border-[#0020C2]"
          />
        </div>

        <div className="bg-gray-50 rounded-lg p-2 text-xs space-y-0.5">
          <div className="flex justify-between text-gray-600">
            <span>Subtotal</span><span className="font-mono">{currency} {net.toFixed(2)}</span>
          </div>
          <div className="flex justify-between text-gray-600">
            <span>Tax ({taxPct}%)</span><span className="font-mono">{currency} {taxAmt.toFixed(2)}</span>
          </div>
          <div className="flex justify-between font-bold text-gray-900 pt-0.5 border-t border-gray-200">
            <span>Total</span><span className="font-mono">{currency} {total.toFixed(2)}</span>
          </div>
        </div>

        <button
          onClick={submit}
          disabled={!canSubmit}
          className="w-full bg-[#0020C2] text-white py-2 rounded-lg text-xs font-bold
            uppercase tracking-wider hover:bg-[#001AA3] disabled:opacity-40">
          Submit line items
        </button>
      </div>
    );
  }
  /* ── End-of-flow multi-PDF attachment upload (skippable) ─────────────────────
   Rendered near the end of a chat-built invoice. next_field_ui.uiType ===
   "invoice_attachment_upload". Lets the user add one OR MORE PDFs (line-item
   card style), then Send them all — or Skip. There is no processing: the files
   are attached to the Oracle invoice as-is at create time.
   On Send it hands the File[] up to the parent (which base64-encodes and posts
   them with attachment_mode="attach"), then the parent sends
   __ATTACHMENT_ADDED__; Skip sends __SKIP_ATTACHMENT__.                        */
function InvoiceAttachmentUpload({ onUpload, onSkip, busy }) {
  const fileInputRef = React.useRef(null);
  const [files, setFiles] = React.useState([]);

  const addFiles = (picked) => setFiles((prev) => [...prev, ...picked]);
  const removeFile = (i) => setFiles((prev) => prev.filter((_, idx) => idx !== i));

  return (
    <div className="mt-2 border border-[#0020C2]/20 rounded-xl bg-white p-3 space-y-3"
      data-testid="chat-invoice-attachment-upload">
      <div className="text-[10px] font-bold uppercase tracking-wider text-[#0020C2] flex items-center gap-1">
        <Sparkle size={10} weight="fill" /> Add supporting documents (optional)
      </div>
      <p className="text-[11px] text-gray-500">
        Attach one or more PDFs to this invoice, or skip. Files are attached as-is.
      </p>

      <input
        ref={fileInputRef}
        type="file"
        accept=".pdf,.png,.jpg,.jpeg"
        multiple
        className="hidden"
        onChange={(e) => {
          const picked = Array.from(e.target.files || []);
          e.target.value = "";
          if (picked.length) addFiles(picked);
        }}
      />

      {files.length > 0 && (
        <div className="space-y-1">
          {files.map((f, i) => (
            <div key={i} className="flex items-center gap-1.5 text-[11px] text-gray-700">
              <Paperclip size={11} weight="bold" className="text-gray-400 shrink-0" />
              <span className="truncate flex-1">{f.name}</span>
              <button onClick={() => removeFile(i)} className="text-[#DC2626] shrink-0 p-1" title="Remove">
                <Trash size={11} weight="bold" />
              </button>
            </div>
          ))}
        </div>
      )}

      <button
        onClick={() => fileInputRef.current?.click()}
        className="text-[11px] font-bold text-[#0020C2] hover:underline flex items-center gap-1">
        + Add PDF
      </button>

      <div className="flex gap-2">
        <button
          onClick={() => files.length && onUpload(files)}
          disabled={!files.length || busy}
          className="flex-1 bg-[#0020C2] text-white py-2 rounded-lg text-xs font-bold
            uppercase tracking-wider hover:bg-[#001AA3] disabled:opacity-40">
          {busy ? "Uploading…" : `Send ${files.length || ""} document${files.length === 1 ? "" : "s"}`.trim()}
        </button>
        <button
          onClick={onSkip}
          disabled={busy}
          className="flex-1 border border-gray-300 text-gray-600 py-2 rounded-lg
            text-xs font-bold uppercase tracking-wider hover:bg-gray-50 disabled:opacity-40">
          Skip
        </button>
      </div>
    </div>
  );
}


  /* ── Markdown renderer for assistant messages ────────────────────────────────
    Renders bold, tables, lists and headings cleanly. User messages stay plain
    text (they never contain markdown). Tables scroll horizontally on narrow
    bubbles. Styling matches the Vaku palette.                                */
  function ChatMarkdown({ children }) {
    return (
      <div className="chat-md text-sm leading-relaxed">
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            p: ({ node, ...props }) => <p className="mb-2 last:mb-0 whitespace-pre-wrap" {...props} />,
            strong: ({ node, ...props }) => <strong className="font-bold text-gray-900" {...props} />,
            ul: ({ node, ...props }) => <ul className="list-disc pl-5 mb-2 space-y-0.5" {...props} />,
            ol: ({ node, ...props }) => <ol className="list-decimal pl-5 mb-2 space-y-0.5" {...props} />,
            li: ({ node, ...props }) => <li className="text-sm" {...props} />,
            h1: ({ node, ...props }) => <h1 className="text-base font-bold mb-1 mt-2" {...props} />,
            h2: ({ node, ...props }) => <h2 className="text-sm font-bold mb-1 mt-2" {...props} />,
            h3: ({ node, ...props }) => <h3 className="text-sm font-bold mb-1 mt-2 text-[#0020C2]" {...props} />,
            code: ({ node, inline, ...props }) =>
              inline
                ? <code className="font-mono text-[12px] bg-gray-100 px-1 py-0.5 rounded" {...props} />
                : <code className="font-mono text-[12px] block bg-gray-50 border border-gray-200 rounded p-2 overflow-x-auto" {...props} />,
            table: ({ node, ...props }) => (
              <div className="overflow-x-auto my-2">
                <table className="w-full text-xs border-collapse" {...props} />
              </div>
            ),
            thead: ({ node, ...props }) => <thead className="bg-[#0020C2]/5" {...props} />,
            th: ({ node, ...props }) => (
              <th className="border border-gray-200 px-2 py-1.5 text-left font-bold uppercase tracking-wider text-[10px] text-gray-600" {...props} />
            ),
            td: ({ node, ...props }) => (
              <td className="border border-gray-200 px-2 py-1.5 text-gray-800" {...props} />
            ),
            a: ({ node, ...props }) => <a className="text-[#0020C2] underline" {...props} />,
            hr: () => <hr className="my-2 border-gray-200" />,
          }}
        >
          {children}
        </ReactMarkdown>
      </div>
    );
  }

  /* ── Supplier Ageing dashboard widget ────────────────────────────────────────
    Rendered when a supplier-ageing tool returns a `widget` object
    (msg.result.widget with type "ageing_dashboard"). Shows, per currency:
      - KPI strip (total owed, overdue %, risk)
      - the ageing buckets as a horizontal stacked bar + table
      - top suppliers (BU scope)
      - insights + recommendations
    Pure presentational; all numbers come from the backend (computed in code).
    Rendered inside ChatBubble below when
    msg.result?.widget?.type === "ageing_dashboard".                          */
  function AgeingDashboard({ widget }) {
    if (!widget || !widget.currencies) return null;

    const BUCKET_COLORS = {
      "Current": "#10B981",
      "1-30":    "#3B82F6",
      "31-60":   "#F59E0B",
      "61-90":   "#F97316",
      "90+":     "#DC2626",
    };
    const RISK_COLORS = {
      LOW: "#10B981", MEDIUM: "#F59E0B", HIGH: "#F97316", CRITICAL: "#DC2626",
    };

    const currencies = Object.entries(widget.currencies);

    return (
      <div className="mt-2 space-y-3" data-testid="ageing-dashboard">
        <div className="text-[10px] font-bold uppercase tracking-wider text-[#0020C2] flex items-center gap-1">
          <Sparkle size={10} weight="fill" />
          Ageing — {widget.scope_type === "supplier" ? "Supplier" : "Business Unit"}: {widget.scope_value}
          {widget.approximate && (
            <span className="ml-1 text-[9px] font-normal text-amber-600 normal-case">
              (BU estimate)
            </span>
          )}
        </div>

        {currencies.map(([currency, c]) => {
          const total = c.total_liability || 0;
          return (
            <div key={currency} className="border border-gray-200 rounded-xl bg-white p-3 space-y-3">
              {/* header row: currency + KPIs */}
              <div className="flex items-center justify-between flex-wrap gap-2">
                <div className="text-sm font-black text-gray-900">{currency}</div>
                <div className="flex items-center gap-3 text-[11px]">
                  <div className="text-right">
                    <div className="text-gray-400 uppercase tracking-wider text-[9px] font-bold">Owed</div>
                    <div className="font-bold text-gray-900">{currency} {total.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</div>
                  </div>
                  <div className="text-right">
                    <div className="text-gray-400 uppercase tracking-wider text-[9px] font-bold">Overdue</div>
                    <div className="font-bold text-gray-900">{c.overdue_ratio}%</div>
                  </div>
                  <div className="text-right">
                    <div className="text-gray-400 uppercase tracking-wider text-[9px] font-bold">Risk</div>
                    <div className="font-bold" style={{ color: RISK_COLORS[c.risk_level] || "#374151" }}>
                      {c.risk_score}/100 · {c.risk_level}
                    </div>
                  </div>
                </div>
              </div>

              {/* stacked bucket bar */}
              {total > 0 && (
                <div className="space-y-1">
                  <div className="flex h-3 rounded-full overflow-hidden bg-gray-100">
                    {c.buckets.map((b) => {
                      const pct = total > 0 ? (b.amount / total) * 100 : 0;
                      if (pct <= 0) return null;
                      return (
                        <div
                          key={b.bucket}
                          style={{ width: `${pct}%`, background: BUCKET_COLORS[b.bucket] || "#9CA3AF" }}
                          title={`${b.bucket}: ${currency} ${b.amount.toLocaleString()} (${b.percentage}%)`}
                        />
                      );
                    })}
                  </div>
                  <div className="flex flex-wrap gap-2">
                    {c.buckets.map((b) => (
                      <span key={b.bucket} className="inline-flex items-center gap-1 text-[9px] text-gray-600">
                        <span className="w-2 h-2 rounded-sm" style={{ background: BUCKET_COLORS[b.bucket] || "#9CA3AF" }} />
                        {b.bucket}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {/* bucket table */}
              <div className="overflow-x-auto">
                <table className="w-full text-xs border-collapse">
                  <thead className="bg-[#0020C2]/5">
                    <tr>
                      <th className="border border-gray-200 px-2 py-1 text-left text-[10px] font-bold uppercase tracking-wider text-gray-600">Bucket</th>
                      <th className="border border-gray-200 px-2 py-1 text-right text-[10px] font-bold uppercase tracking-wider text-gray-600">Amount</th>
                      <th className="border border-gray-200 px-2 py-1 text-right text-[10px] font-bold uppercase tracking-wider text-gray-600">Inv</th>
                      <th className="border border-gray-200 px-2 py-1 text-right text-[10px] font-bold uppercase tracking-wider text-gray-600">%</th>
                    </tr>
                  </thead>
                  <tbody>
                    {c.buckets.map((b) => (
                      <tr key={b.bucket}>
                        <td className="border border-gray-200 px-2 py-1">
                          <span className="inline-flex items-center gap-1.5">
                            <span className="w-2 h-2 rounded-sm" style={{ background: BUCKET_COLORS[b.bucket] || "#9CA3AF" }} />
                            {b.bucket}
                          </span>
                        </td>
                        <td className="border border-gray-200 px-2 py-1 text-right font-mono">{currency} {b.amount.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                        <td className="border border-gray-200 px-2 py-1 text-right">{b.invoice_count}</td>
                        <td className="border border-gray-200 px-2 py-1 text-right">{b.percentage}%</td>
                      </tr>
                    ))}
                    <tr className="font-bold bg-gray-50">
                      <td className="border border-gray-200 px-2 py-1">Total</td>
                      <td className="border border-gray-200 px-2 py-1 text-right font-mono">{currency} {total.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</td>
                      <td className="border border-gray-200 px-2 py-1 text-right">{c.invoice_count}</td>
                      <td className="border border-gray-200 px-2 py-1 text-right">100%</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              {/* top suppliers (BU scope) */}
              {c.top_suppliers && c.top_suppliers.length > 0 && widget.scope_type === "business_unit" && (
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-wider text-gray-500 mb-1">Top suppliers</div>
                  <div className="space-y-1">
                    {c.top_suppliers.map((s) => (
                      <div key={s.supplier_name} className="flex items-center gap-2 text-[11px]">
                        <div className="min-w-0 flex-1 truncate text-gray-700">{s.supplier_name}</div>
                        <div className="w-24 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                          <div className="h-full bg-[#0020C2]" style={{ width: `${s.percentage_of_total}%` }} />
                        </div>
                        <div className="font-mono text-gray-900 w-28 text-right">{currency} {s.total_outstanding.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2})}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* insights */}
              {c.insights && c.insights.length > 0 && (
                <div className="space-y-1">
                  {c.insights.map((ins, i) => {
                    const color = ins.severity === "critical" ? "text-red-700 bg-red-50 border-red-200"
                      : ins.severity === "warning" ? "text-amber-700 bg-amber-50 border-amber-200"
                      : "text-blue-700 bg-blue-50 border-blue-200";
                    return (
                      <div key={i} className={`text-[11px] px-2 py-1 rounded border ${color}`}>
                        {ins.message}
                      </div>
                    );
                  })}
                </div>
              )}

              {/* recommendations */}
              {c.recommendations && c.recommendations.length > 0 && (
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-wider text-gray-500 mb-1">Recommended actions</div>
                  <ul className="list-disc pl-4 space-y-0.5 text-[11px] text-gray-700">
                    {c.recommendations.map((r, i) => <li key={i}>{r}</li>)}
                  </ul>
                </div>
              )}
            </div>
          );
        })}

        {/* status notes */}
        {widget.notes && (widget.notes.on_hold_count > 0 || widget.notes.excluded_unvalidated_count > 0) && (
          <div className="text-[10px] text-gray-400 space-y-0.5">
            {widget.notes.on_hold_count > 0 && <div>· {widget.notes.on_hold_count} invoice(s) on hold (included, flagged)</div>}
            {widget.notes.excluded_unvalidated_count > 0 && <div>· {widget.notes.excluded_unvalidated_count} unvalidated invoice(s) excluded from totals</div>}
          </div>
        )}
      </div>
    );
  }

  /* ── Supplier / Business Unit LOV picker (search-as-you-type + scroll) ────────
    Rendered when a supplier-ageing turn returns result.lov = { kind }.
      kind="supplier"       -> GET /erp-agents/supplier-ageing/lov/suppliers
      kind="business_unit"  -> GET /erp-agents/supplier-ageing/lov/business-units
    Server-side paginated: typing filters server-side, scrolling to the bottom
    loads the next page. On select, calls onPick(name) which the chat turns into
    an age command.                                                            */
  function SupplierAgeingLov({ kind = "supplier", onPick }) {
    const [q, setQ] = React.useState("");
    const [items, setItems] = React.useState([]);
    const [offset, setOffset] = React.useState(0);
    const [hasMore, setHasMore] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [err, setErr] = React.useState("");
    const listRef = React.useRef(null);
    const debounceRef = React.useRef(null);
    const reqIdRef = React.useRef(0);

    const PAGE = 25;
    const path = kind === "business_unit"
      ? "/erp-agents/supplier-ageing/lov/business-units"
      : "/erp-agents/supplier-ageing/lov/suppliers";
    const noun = kind === "business_unit" ? "business unit" : "supplier";

    const fetchPage = React.useCallback(async (search, nextOffset, append) => {
      const myReq = ++reqIdRef.current;
      setLoading(true);
      setErr("");
      try {
        const { data } = await api.get(path, {
          params: { search, offset: nextOffset, limit: PAGE },
        });
        if (myReq !== reqIdRef.current) return; // ignore stale
        const newItems = data?.items || [];
        setItems((prev) => (append ? [...prev, ...newItems] : newItems));
        setHasMore(!!data?.has_more);
        setOffset(nextOffset + newItems.length);
        if (data?.error) setErr("Couldn't load — check the Oracle profile.");
      } catch (e) {
        if (myReq !== reqIdRef.current) return;
        setErr(e?.response?.data?.detail || e.message || "Load failed");
      } finally {
        if (myReq === reqIdRef.current) setLoading(false);
      }
    }, [path]);

    // Initial load + debounced search.
    React.useEffect(() => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
      debounceRef.current = setTimeout(() => {
        setOffset(0);
        fetchPage(q.trim(), 0, false);
        if (listRef.current) listRef.current.scrollTop = 0;
      }, 300);
      return () => clearTimeout(debounceRef.current);
    }, [q, fetchPage]);

    const onScroll = (e) => {
      const el = e.target;
      if (!loading && hasMore && el.scrollHeight - el.scrollTop - el.clientHeight < 40) {
        fetchPage(q.trim(), offset, true);
      }
    };

    return (
      <div className="mt-2 border border-[#0020C2]/25 rounded-xl bg-white overflow-hidden shadow-sm"
        data-testid={`ageing-lov-${kind}`}>
        <div className="flex items-center gap-2 px-3 py-2 border-b border-gray-100 bg-[#0020C2]/5">
          <Sparkle size={11} weight="fill" className="text-[#0020C2]" />
          <span className="text-[10px] font-bold uppercase tracking-wider text-[#0020C2]">
            Browse {noun}s
          </span>
        </div>

        <div className="p-2">
          <input
            autoFocus
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder={`Type to search ${noun}s — e.g. "garden"`}
            className="w-full px-3 py-2 text-xs border border-gray-300 rounded-lg
              focus:outline-none focus:border-[#0020C2]"
          />
        </div>

        <div ref={listRef} onScroll={onScroll} className="max-h-64 overflow-y-auto">
          {err && (
            <div className="px-3 py-2 text-xs text-red-600">{err}</div>
          )}
          {!err && items.length === 0 && !loading && (
            <div className="px-3 py-3 text-xs text-gray-400">
              No {noun}s found{q.trim() ? ` for "${q.trim()}"` : ""}.
            </div>
          )}
          {items.map((it, i) => (
            <button
              key={`${it.name}-${i}`}
              onClick={() => onPick?.(it.name)}
              className="w-full text-left px-3 py-2 text-xs hover:bg-[#0020C2]/5
                border-b border-gray-50 last:border-0 flex items-center gap-2">
              <span className="min-w-0 flex-1 truncate text-gray-800">{it.name}</span>
              {it.number && (
                <span className="text-[10px] text-gray-400 font-mono shrink-0">#{it.number}</span>
              )}
            </button>
          ))}
          {loading && (
            <div className="px-3 py-2 text-xs text-gray-400 flex items-center gap-2">
              <span className="w-3 h-3 border-2 border-gray-300 border-t-[#0020C2] rounded-full animate-spin" />
              Loading…
            </div>
          )}
          {!loading && hasMore && (
            <div className="px-3 py-1.5 text-[10px] text-gray-400 text-center">Scroll for more…</div>
          )}
        </div>
      </div>
    );
  }

  /* ── Chat bubble ─────────────────────────────────────────────────────────── */
  /* FIX: this component now declares BOTH onOptionClick and onMultiSubmit as
    real props (previously onMultiSubmit was referenced inside the function
    body without ever being destructured — a ReferenceError as soon as a
    "multi_select" field UI was rendered). sessionId is also now a prop so the
    receipt-upload widget can reach the active chat session.                  */
  function ChatBubble({ msg, sessionId, onOptionClick, onMultiSubmit, isSupplierChat, onInvoiceAttach, onInvoiceSkipAttach }) {
    const { openAgent } = useErp();
    const isUser = msg.role === "user";
    const fieldUi = !isUser && !msg.loading ? msg.result?.next_field_ui : null;
    return (
      <div className={`flex gap-2.5 ${isUser ? "flex-row-reverse" : "flex-row"}`}>
        {!isUser && (
          <div className="shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-[#0020C2] text-white">
            <Sparkle size={11} weight="fill" />
          </div>
        )}

        <div className={`max-w-[82%] rounded-2xl px-3.5 py-2 text-sm leading-relaxed
          ${isUser
            ? "bg-[#0020C2] text-white rounded-tr-sm"
            : "bg-white border border-gray-200 text-gray-900 rounded-tl-sm shadow-sm"}`}>

          {msg.loading && (
            <div className="flex items-center gap-1 py-0.5">
              {[0, 150, 300].map((d) => (
                <span key={d} className="w-1.5 h-1.5 bg-gray-400 rounded-full animate-bounce"
                  style={{ animationDelay: `${d}ms` }} />
              ))}
            </div>
          )}

          {!msg.loading && msg.text && (
            isUser ? (
              <p className="whitespace-pre-wrap">{msg.text}</p>
            ) : openAgent === "finance-variance" ? (
              <div
                className="
          prose
          prose-sm
          max-w-none
          prose-p:my-2
          prose-h2:mt-4
          prose-h2:mb-2
          prose-ul:my-2

          [&_table]:w-1/3
          [&_table]:border
          [&_table]:border-collapse
          [&_table]:my-3

          [&_thead]:bg-gray-100

          [&_th]:border
          [&_th]:border-gray-300
          [&_th]:px-3
          [&_th]:py-2
          [&_th]:text-left
          [&_th]:font-semibold

          [&_td]:border
          [&_td]:border-gray-300
          [&_td]:px-3
          [&_td]:py-2

          [&_tr:nth-child(even)]:bg-gray-50
        "
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(msg.text),
                }}
              />
            ) : (
              <ChatMarkdown>{msg.text}</ChatMarkdown>
            )
          )}

          {/* Root-cause fix: backend now sends next_field_ui = {field, uiType,
              options}. When present, render clickable selection controls
              instead of requiring the user to type the value. */}

                  {fieldUi?.uiType === "multi_select" && (
            <MultiSelectChatOptions fieldUi={fieldUi} onSubmit={(values) => onMultiSubmit?.(values)} />
          )}
          {/* receipt-create: upload document to extract Receipt Number
          {fieldUi?.uiType === 'attachment_upload' && (
            <ReceiptAttachmentUpload fieldUi={fieldUi} onUploaded={onOptionClick} />
          )} */}

          {fieldUi?.uiType === "attachment_gate" && (
            <div className="mt-2 rounded-lg border border-[#0020C2]/20 overflow-hidden bg-white" data-testid="chat-attachment-gate">
              <div className="px-3 py-2 text-xs text-gray-500 bg-gray-50 border-b border-gray-100">
                {fieldUi.uploadedCount > 0
                  ? `${fieldUi.uploadedCount} file${fieldUi.uploadedCount > 1 ? "s" : ""} uploaded`
                  : "No files uploaded yet — use the 📎 attach button"}
              </div>
              {fieldUi.uploadedCount > 0 && fieldUi.options?.length > 0 && (
                <button
                  onClick={() => onOptionClick?.(fieldUi.options[0])}
                  data-testid="attachment-done-btn"
                  className="w-full text-xs font-bold px-3 py-2 bg-[#0020C2] text-white hover:bg-[#001AA3] transition-colors"
                >
                  Done — proceed with {fieldUi.uploadedCount} file{fieldUi.uploadedCount > 1 ? "s" : ""}
                </button>
              )}
            </div>
          )}
          
          {fieldUi?.uiType === "searchable_dropdown" && (
            <SearchableChatOptions fieldUi={fieldUi} onPick={(opt) => onOptionClick?.(opt)} />
          )}

          {/* Editable GL + site recommendations box (non-PO). */}
          {fieldUi?.uiType === "editable_recommendations" && (
            <EditableRecommendations fieldUi={fieldUi} onSubmit={(text) => onOptionClick?.({ value: text })} />
          )}

          {/* Line-items builder with [+] add-line and tax % (non-PO). */}
          {fieldUi?.uiType === "line_items_builder" && (
            <LineItemsBuilder fieldUi={fieldUi} onSubmit={(text) => onOptionClick?.({ value: text })} />
          )}
          {/* End-of-flow: optional multi-PDF supporting attachment, skippable
            (invoice-create). No processing — attached as-is at create time. */}
        {fieldUi?.uiType === "invoice_attachment_upload" && (
          <InvoiceAttachmentUpload
            onUpload={(fileList) => onInvoiceAttach?.(fileList)}
            onSkip={() => onInvoiceSkipAttach?.()}
            busy={msg.attachBusy}
          />
        )}

          {fieldUi && !["searchable_dropdown", "editable_recommendations", "line_items_builder", "multi_select", "attachment_gate", "attachment_upload"].includes(fieldUi.uiType) && fieldUi.options?.length > 0 && (
            <div
              className={fieldUi.uiType === "dropdown" ? "mt-2 flex flex-col gap-1" : "mt-2 flex flex-wrap gap-1.5"}
              data-testid={`chat-field-ui-${fieldUi.field}`}
            >
              {fieldUi.options.map((opt) => (
                <button
                  key={opt.value}
                  onClick={() => onOptionClick?.(opt)}
                  className="text-xs px-3 py-1.5 border border-[#0020C2]/30 rounded-full text-[#0020C2] bg-[#0020C2]/5 hover:bg-[#0020C2]/10 transition-colors text-left"
                >
                  {opt.label}
                </button>
              ))}
            </div>
          )}

          {!msg.loading && msg.result && (
            <div className="mt-2 space-y-2">
              {(() => {
                const s = (msg.result.status || "").toLowerCase();
                const isOk = s === "ok" || s === "success" || s === "completed";
                const isErr = s === "oracle_error" || s === "llm_error" || s === "failed" || s === "unconfigured";
                if (!isOk && !isErr) return null;   // hide badge for in-progress states
                return (
                  <div className={`inline-flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-wider 
                                      ${isOk ? "bg-emerald-100 text-emerald-800" : "bg-red-100 text-red-700"}`}>
                    
                    {/* {isOk
                      ? <CheckCircle size={10} weight="fill" />
                      : <WarningCircle size={10} weight="fill" />} */}
                    {msg.result.http_status ? ` · HTTP ${msg.result.http_status}` : ""}
                  </div>
                );
              })()}

                          {/* Downloadable report (PDF / Excel) — rendered when the backend
                  returns result.download = { filename, url, format, scope }.
                  Fetched THROUGH api so the auth token is attached (a plain
                  anchor href opens a new tab with no Authorization header and
                  the endpoint returns "Not authenticated"). */}
              {msg.result.widget?.type === "ageing_dashboard" && (
                <AgeingDashboard widget={msg.result.widget} />
              )}

              {msg.result.lov?.kind && (
                <SupplierAgeingLov
                  kind={msg.result.lov.kind}
                  onPick={(name) => onOptionClick?.({
                    value: msg.result.lov.kind === "business_unit"
                      ? `Age this business unit: ${name}`
                      : `Age this supplier: ${name}`,
                  })}
                />
              )}

              {msg.result.download?.url && (
                <button
                  onClick={async () => {
                    try {
                      const resp = await api.get(msg.result.download.url, { responseType: "blob" });
                      const blobUrl = window.URL.createObjectURL(resp.data);
                      const a = document.createElement("a");
                      a.href = blobUrl;
                      a.download = msg.result.download.filename || "report";
                      document.body.appendChild(a);
                      a.click();
                      a.remove();
                      window.URL.revokeObjectURL(blobUrl);
                    } catch (e) {
                      window.alert(`Download failed: ${e?.response?.status === 404
                        ? "the report expired — please regenerate it."
                        : (e?.message || "unknown error")}`);
                    }
                  }}
                  className="inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider
                    border border-[#0020C2] text-[#0020C2] bg-[#0020C2]/5 px-3 py-1.5 rounded-lg
                    hover:bg-[#0020C2] hover:text-white transition-colors">
                  <CheckCircle size={12} weight="fill" />
                  Download {String(msg.result.download.format || "").toUpperCase()} report
                </button>
              )}

              {msg.result.insights?.headline && (
                <div className="bg-blue-50 border border-blue-200 rounded-xl p-3">
                  <div className="text-[10px] font-bold uppercase tracking-wider text-[#0020C2] mb-1 flex items-center gap-1">
                    <Sparkle size={10} weight="fill" /> AI Insights
                  </div>
                  <div className="text-xs font-semibold text-gray-900 mb-1">{msg.result.insights.headline}</div>
                  {msg.result.insights.bullets?.length > 0 && (
                    <ul className="text-[11px] text-gray-700 space-y-0.5 list-disc pl-4">
                      {msg.result.insights.bullets.map((b, i) => <li key={i}>{b}</li>)}
                    </ul>
                  )}
                </div>
              )}

              {msg.result.oracle_response && !isSupplierChat && (
                <details>
                  <summary className="text-[10px] font-bold uppercase tracking-wider text-gray-500 cursor-pointer hover:text-gray-700">
                    Oracle response ↓
                  </summary>
                  <pre className="text-[10px] font-mono bg-gray-50 border border-gray-200 rounded p-2 mt-1 overflow-x-auto max-h-28">
                    {JSON.stringify(msg.result.oracle_response, null, 2).slice(0, 1200)}
                  </pre>
                </details>
              )}

              {["ok", "success"].includes((msg.result.status || "").toLowerCase()) && msg.result.parsed_payload && msg.onSave && (
                <button onClick={msg.onSave}
                  className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider
                    border border-amber-300 text-amber-700 bg-amber-50 px-2 py-0.5 hover:bg-amber-100 rounded-full">
                  <Star size={9} weight="fill" /> Save query
                </button>
              )}
            </div>
          )}

          {msg.timestamp && (
            <div className={`text-[9px] mt-1 opacity-40 ${isUser ? "text-right" : "text-left"}`}>
              {msg.timestamp}
            </div>
          )}
        </div>
      </div>
    );
  }

  /* ── Saved queries block ─────────────────────────────────────────────────── */
  function SavedQueries({
    saved, schedsFor, busy, openSchedFor, setOpenSchedFor,
    schedForm, setSchedForm, replay, removeSaved, createSchedule, toggleSchedule, deleteSchedule,
  }) {
    if (!saved.length) return null;
    return (
      <div data-testid="agent-saved-queries" className="border border-gray-200 bg-amber-50 p-3">
        <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-gray-600 mb-2 flex items-center gap-2">
          <Star size={12} weight="fill" className="text-amber-500" /> Saved · {saved.length}
        </div>
        <div className="space-y-1.5">
          {saved.map((s) => {
            const ss = schedsFor(s.id);
            return (
              <div key={s.id} className="bg-white border border-gray-200" data-testid={`saved-${s.id}`}>
                <div className="flex items-center gap-2 px-3 py-2">
                  <div className="min-w-0 flex-1">
                    <div className="text-xs font-semibold truncate">{s.label}</div>
                    <div className="text-[10px] text-gray-500 font-mono">
                      {s.run_count > 0 ? `Run ${s.run_count}×` : "Never replayed"}
                    </div>
                  </div>
                  <button
                    onClick={() => setOpenSchedFor(openSchedFor === s.id ? null : s.id)}
                    className="text-gray-500 hover:text-[#0020C2] text-[10px] font-bold inline-flex items-center gap-1 shrink-0">
                    <Calendar size={11} weight="bold" /> Sched
                  </button>
                  <button
                    onClick={() => replay(s.id)}
                    disabled={busy}
                    data-testid={`agent-replay-${s.id}`}
                    className="text-[#0020C2] text-[10px] font-bold inline-flex items-center gap-1 shrink-0 disabled:opacity-40 hover:underline">
                    <Lightning size={11} weight="bold" /> Replay
                  </button>
                  <button onClick={() => removeSaved(s.id)} className="text-[#DC2626] shrink-0">
                    <Trash size={11} weight="bold" />
                  </button>
                </div>

                {ss.length > 0 && (
                  <div className="border-t border-gray-100 px-3 py-1.5 space-y-1 bg-gray-50">
                    {ss.map((sch) => (
                      <div key={sch.id} className="flex items-center gap-2 text-[10px]">
                        <span className="font-mono font-bold text-gray-700 truncate flex-1">{describeSchedule(sch)}</span>
                        <span className={`px-1 py-0.5 text-[8px] font-bold uppercase rounded
                          ${sch.enabled ? "bg-green-100 text-green-800" : "bg-gray-200 text-gray-500"}`}>
                          {sch.enabled ? "On" : "Off"}
                        </span>
                        <button onClick={() => toggleSchedule(sch.id)} className="text-gray-400 hover:text-[#0020C2]">
                          {sch.enabled ? <ToggleRight size={14} weight="fill" /> : <ToggleLeft size={14} />}
                        </button>
                        <button onClick={() => deleteSchedule(sch.id)} className="text-[#DC2626]">
                          <Trash size={10} weight="bold" />
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                {openSchedFor === s.id && (
                  <div className="border-t border-gray-100 px-3 py-2 bg-blue-50 space-y-2">
                    <div className="grid grid-cols-2 gap-1.5">
                      <select
                        value={schedForm.cadence}
                        onChange={(e) => setSchedForm({ ...schedForm, cadence: e.target.value })}
                        className="border border-gray-300 px-1.5 py-1 text-[10px] col-span-2">
                        <option value="daily">Daily</option>
                        <option value="weekly">Weekly</option>
                        <option value="monthly">Monthly</option>
                      </select>
                      {schedForm.cadence === "weekly" && (
                        <select
                          value={schedForm.day_of_week}
                          onChange={(e) => setSchedForm({ ...schedForm, day_of_week: parseInt(e.target.value) })}
                          className="border border-gray-300 px-1.5 py-1 text-[10px]">
                          {DOW.map((d, i) => <option key={d} value={i}>{d}</option>)}
                        </select>
                      )}
                      {schedForm.cadence === "monthly" && (
                        <select
                          value={schedForm.day_of_month}
                          onChange={(e) => setSchedForm({ ...schedForm, day_of_month: parseInt(e.target.value) })}
                          className="border border-gray-300 px-1.5 py-1 text-[10px]">
                          {Array.from({ length: 28 }, (_, i) => i + 1).map((d) => (
                            <option key={d} value={d}>Day {d}</option>
                          ))}
                        </select>
                      )}
                      <select
                        value={schedForm.hour_utc}
                        onChange={(e) => setSchedForm({ ...schedForm, hour_utc: parseInt(e.target.value) })}
                        className="border border-gray-300 px-1.5 py-1 text-[10px] font-mono">
                        {Array.from({ length: 24 }, (_, i) => i).map((h) => (
                          <option key={h} value={h}>{String(h).padStart(2, "0")}:00 UTC</option>
                        ))}
                      </select>
                      <button
                        onClick={() => createSchedule(s.id)}
                        className="bg-[#0020C2] text-white py-1 text-[10px] font-bold uppercase tracking-wider col-span-2">
                        Save Schedule
                      </button>
                    </div>
                    <button
                      onClick={() => setOpenSchedFor(null)}
                      className="text-[10px] text-gray-500 hover:text-gray-700 w-full text-center">
                      Cancel
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  /* ── PO Decision Card ────────────────────────────────────────────────────── */
  function PODecisionCard({ onYes, onSkip }) {
    const [showInput, setShowInput] = React.useState(false);
    const [poInput, setPoInput] = React.useState("");

    return (
      <div className="rounded-xl p-4 shadow-sm border border-gray-200 bg-white"
        style={{ borderLeft: "3px solid #0020C2" }}>
        <div className="flex items-center gap-2 mb-1">
          <div className="w-2 h-2 bg-[#0020C2] rounded-full" />
          <span className="text-[10px] font-bold text-gray-500 uppercase tracking-widest">
            Purchase Order
          </span>
        </div>
        <p className="text-sm font-semibold text-gray-900 mb-1">
          Do you have a PO number for this invoice?
        </p>
        <p className="text-xs text-gray-500 mb-3 leading-relaxed">
          PO invoices are matched to an existing PO in Oracle.
          Leave blank to create a standalone invoice without a PO.
        </p>

        {!showInput ? (
          <div className="flex gap-2 flex-wrap">
            <button
              onClick={() => setShowInput(true)}
              className="px-3 py-1.5 rounded-full text-xs font-semibold transition-all"
              style={{ background: "rgba(0,32,194,0.08)", border: "1px solid rgba(0,32,194,0.25)", color: "#0020C2" }}>
              ✅ Yes, I have a PO number
            </button>
            <button
              onClick={onSkip}
              className="px-3 py-1.5 rounded-full text-xs font-semibold transition-all"
              style={{ background: "#F9FAFB", border: "1px solid #E5E7EB", color: "#6B7280" }}>
              ⏭ Skip — create without PO
            </button>
          </div>
        ) : (
          <div className="flex gap-2 mt-1">
            <input
              type="text"
              value={poInput}
              onChange={(e) => setPoInput(e.target.value)}
              onKeyDown={(e) => { if (e.key === "Enter" && poInput.trim()) onYes(poInput.trim()); }}
              placeholder="Enter PO number e.g. PO-2024-001"
              autoFocus
              className="flex-1 px-3 py-1.5 text-sm rounded-full border border-gray-300 focus:outline-none focus:border-[#0020C2]"
            />
            <button
              onClick={() => poInput.trim() && onYes(poInput.trim())}
              className="px-3 py-1.5 rounded-full text-xs font-bold text-white whitespace-nowrap"
              style={{ background: "#0020C2" }}>
              Add PO →
            </button>
          </div>
        )}
      </div>
    );
  }

  /* ── Invoice Confirm Popup ───────────────────────────────────────────────── */
  function ProgressBar({ progress }) {
    if (!progress) return null;
    const pctMatch = progress.match(/\((\d+)%\)/);
    const stepMatch = progress.match(/(\d+)\/(\d+)/);
    if (!pctMatch || !stepMatch) return null;
    const pct = parseInt(pctMatch[1], 10);
    const [, done, total] = stepMatch;
    return (
      <div className="px-4 pt-3 pb-1" data-testid="copilot-progress">
        <div className="flex justify-between text-xs text-gray-500 mb-1">
          <span>Step {done} of {total}</span>
          <span>{pct}% complete</span>
        </div>
        <div className="h-1.5 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-[#0020C2] transition-all duration-300" style={{ width: `${pct}%` }} />
        </div>
      </div>
    );
  }

  const SUPPLIER_QUICK_ACTIONS = [
    "Create Supplier", "Check Supplier Status", "Continue Draft",
    "Supplier Guidelines", "Contact Support",
  ];
  function QuickActions({ onPick }) {
    return (
      <div className="flex gap-2 flex-wrap px-4 pb-2" data-testid="copilot-quick-actions">
        {SUPPLIER_QUICK_ACTIONS.map((a) => (
          <button
            key={a}
            onClick={() => onPick(a)}
            className="text-xs px-3 py-1 border border-gray-200 rounded-full text-gray-600 hover:border-[#0020C2] hover:text-[#0020C2] transition-colors"
          >
            {a}
          </button>
        ))}
      </div>
    );
  }

  function CapturedFieldsPanel({ fields }) {
    const entries = Object.entries(fields || {});
    if (!entries.length) return null;
    return (
      <details className="mx-4 mb-2 border border-gray-100 rounded-lg" data-testid="copilot-captured-fields">
        <summary className="cursor-pointer text-xs font-bold text-gray-500 px-3 py-2">
          Captured so far ({entries.length})
        </summary>
        <div className="px-3 pb-2 space-y-1">
          {entries.map(([field, value]) => (
            <div key={field} className="flex justify-between text-xs border-t border-gray-50 pt-1">
              <span className="text-gray-400">{field.replace(/_/g, " ")}</span>
              <span className="font-mono text-gray-700">{String(value)}</span>
            </div>
          ))}
        </div>
      </details>
    );
  }
  // SUPPLIER-SPECIFIC CODE MOVED TO SupplierAgentModal.jsx
  // These components are kept here for reference but are no longer used
  // by AgentRunModal — supplier routing sends directly to SupplierAgentModal.

  // function ProgressBar({ progress }) { ... }
  // const SUPPLIER_QUICK_ACTIONS = [ ... ]
  // function QuickActions({ onPick }) { ... }
  // function CapturedFieldsPanel({ fields }) { ... }

  // Field *derivation* for Invoice's confirm popup — regex-parses the last
  // AI reply into the {label, value, highlight?} shape ConfirmReviewPopup
  // renders. This stays local to AgentRunModal: the shared popup component
  // has no knowledge of where its `fields` come from.
  function extractInvoiceFields(t) {
    const clean = (t || "").replace(/\*\*/g, "");
    const fields = [];

    const amt = clean.match(/(?:Amount|Total)[^\d]*([\d,]+\.?\d*)/i);
    const cur = clean.match(/\b(AED|USD|EUR|GBP)\b/);
    if (amt) fields.push({ label: "Invoice Amount", value: (cur ? cur[0] + " " : "") + amt[1], highlight: true });

    const buMatch = clean.match(/Business Unit[:\s]*((?:[^\n]){1,60})/i);
    if (buMatch?.[1]?.trim()) fields.push({ label: "Business Unit", value: buMatch[1].trim().replace(/^[-:]\s*/, "") });

    for (const k of ["Supplier:", "Supplier Name", "Supplier"]) {
      const m = clean.match(new RegExp(k + "[:\\s]*((?:[^\\n]){1,60})", "i"));
      if (m?.[1]?.trim()) { fields.push({ label: "Supplier", value: m[1].trim().replace(/^[-:]\s*/, "") }); break; }
    }

    const pt = clean.match(/Payment Terms[:\s]*((?:[^\n]){1,60})/i);
    if (pt?.[1]?.trim()) fields.push({ label: "Payment Terms", value: pt[1].trim().replace(/^[-:]\s*/, "") });

    const inv = clean.match(/Invoice (?:Number|No)[:\s]*((?:[^\n]){1,60})/i);
    if (inv?.[1]?.trim()) fields.push({ label: "Invoice Number", value: inv[1].trim().replace(/^[-:]\s*/, "") });

    const dt = clean.match(/Invoice Date[:\s]*((?:[^\n]){1,60})/i);
    if (dt?.[1]?.trim()) fields.push({ label: "Invoice Date", value: dt[1].trim().replace(/^[-:]\s*/, "") });

    const desc = clean.match(/Description[:\s]*((?:[^\n]){1,60})/i);
    if (desc?.[1]?.trim()) fields.push({ label: "Description", value: desc[1].trim().replace(/^[-:]\s*/, "") });

    return fields.length ? fields : [{ label: "Details", value: "Review the chat above" }];
  }

  /* ── Input bar — top-level component so React never remounts it ──────────────
    IMPORTANT: this must NOT be defined inside AgentRunModal's render body.
    Defining it inside the parent causes React to treat it as a new component
    type on every render → unmount + remount → textarea loses focus after
    every keystroke (the "can only type one word" bug).                      */
  function InputBar({ inputRef, value, onChange, onKeyDown, onSend, busy, placeholder, onAttach, attaching, attachedCount }) {
    const fileInputRef = React.useRef(null);
    return (
      <div className="border-t border-gray-200 px-4 py-3 bg-white shrink-0">
        <div className="flex items-end gap-2 border border-gray-300 bg-gray-50
          focus-within:border-[#0020C2] focus-within:ring-2 focus-within:ring-blue-100">
                    {onAttach && (
            <>
              <input
                ref={fileInputRef}
                type="file"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
                multiple
                className="hidden"
                onChange={(e) => {
                  const files = Array.from(e.target.files || []);
                  if (files.length) onAttach(files);
                  e.target.value = "";
                }}
                data-testid="agent-attach-input"
              />
              <button
                onClick={() => fileInputRef.current?.click()}
                disabled={attaching}
                title="Attach a file (PDF, DOCX, XLSX, PNG, JPG)"
                data-testid="agent-attach-button"
                className="m-2 w-8 h-8 flex items-center justify-center text-gray-500 hover:text-[#0020C2]
                  hover:bg-gray-100 rounded transition-colors shrink-0 disabled:opacity-40 relative">
                {attaching
                  ? <span className="w-3 h-3 border-2 border-gray-300 border-t-[#0020C2] rounded-full animate-spin" />
                  : <Paperclip size={16} weight="bold" />}
                {attachedCount > 0 && (
                  <span className="absolute -top-1 -right-1 w-4 h-4 bg-[#0020C2] text-white text-[9px] rounded-full flex items-center justify-center">
                    {attachedCount}
                  </span>
                )}
              </button>
            </>
          )}

          <textarea
            ref={inputRef}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            rows={1}
            disabled={busy}
            placeholder={placeholder}
            data-testid="agent-prompt"
            className="flex-1 bg-transparent px-3 py-2.5 text-sm resize-none
              outline-none placeholder-gray-400 font-mono disabled:opacity-50 leading-relaxed"
            style={{ minHeight: "2.5rem", maxHeight: "7.5rem" }}
          />
          <button
            onClick={onSend}
            disabled={busy || !value.trim()}
            className="m-2 w-8 h-8 bg-[#0020C2] text-white flex items-center justify-center
              hover:bg-[#001AA3] disabled:opacity-40 transition-colors shrink-0">
            {busy
              ? <span className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin" />
              : <PaperPlaneRight size={14} weight="fill" />}
          </button>
        </div>
        <span className="text-[10px] text-gray-400 mt-1 block">↵ send · shift+↵ new line</span>
      </div>
    );
  }

  /* ── Chat history control — compact, lives in the modal header ───────────────
    New Chat button + a dropdown of past conversations. Designed to sit inline
    in the top-right header, before the profile/settings controls.            */
  function ChatHistoryControl({ agentKey, currentSessionId, onNewChat, onOpenSession }) {
    const [open, setOpen] = React.useState(false);
    const [sessions, setSessions] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const wrapRef = React.useRef(null);

    const load = React.useCallback(async () => {
      if (!agentKey) return;
      setLoading(true);
      try {
        const { data } = await api.get(`/erp-agents/${agentKey}/sessions`);
        setSessions(Array.isArray(data) ? data : []);
      } catch {
        setSessions([]);
      } finally {
        setLoading(false);
      }
    }, [agentKey]);

    React.useEffect(() => { if (open) load(); }, [open, load]);

    // Close the dropdown when clicking outside it.
    React.useEffect(() => {
      if (!open) return;
      const onDocClick = (e) => {
        if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener("mousedown", onDocClick);
      return () => document.removeEventListener("mousedown", onDocClick);
    }, [open]);

    const deleteSession = async (sid, e) => {
      e.stopPropagation();
      if (!window.confirm("Delete this conversation?")) return;
      try {
        await api.delete(`/erp-agents/${agentKey}/sessions/${sid}`);
        load();
      } catch { /* ignore */ }
    };

    return (
      <div className="flex items-center gap-3" ref={wrapRef}>
        <button
          onClick={onNewChat}
          className="text-[11px] font-semibold text-gray-500 hover:text-[#0020C2]
            flex items-center gap-1 shrink-0"
          data-testid="chat-new"
          title="Start a new conversation">
          <Plus size={13} weight="bold" /> New Chat
        </button>

        <div className="relative">
          <button
            onClick={() => setOpen((v) => !v)}
            className="text-[11px] font-semibold text-gray-500 hover:text-[#0020C2]
              flex items-center gap-1"
            data-testid="chat-history-toggle"
            title="Chat history">
            History
            <CaretDown size={10} weight="bold" className={`transition-transform ${open ? "rotate-180" : ""}`} />
          </button>

          {open && (
            <div className="absolute right-0 z-40 mt-2 w-72 bg-white border border-gray-200 rounded-lg shadow-lg
              max-h-80 overflow-y-auto" data-testid="chat-history-list">
              {loading && <div className="px-3 py-2 text-xs text-gray-400">Loading…</div>}
              {!loading && sessions.length === 0 && (
                <div className="px-3 py-2 text-xs text-gray-400">No previous conversations.</div>
              )}
              {sessions.map((s) => (
                <div
                  key={s.session_id}
                  onClick={() => { onOpenSession(s.session_id); setOpen(false); }}
                  className={`px-3 py-2 text-xs cursor-pointer border-b border-gray-50 last:border-0
                    hover:bg-[#0020C2]/5 flex items-center gap-2
                    ${s.session_id === currentSessionId ? "bg-[#0020C2]/5" : ""}`}>
                  <div className="min-w-0 flex-1">
                    <div className="font-semibold text-gray-800 truncate">{s.title}</div>
                    <div className="text-[10px] text-gray-400 flex items-center gap-1.5">
                      <span className={`px-1 py-0.5 rounded text-[8px] font-bold uppercase
                        ${s.status === "completed" ? "bg-emerald-100 text-emerald-700"
                          : s.status === "cancelled" ? "bg-gray-200 text-gray-500"
                          : "bg-blue-100 text-blue-700"}`}>
                        {s.status}
                      </span>
                      {s.updated_at ? new Date(s.updated_at).toLocaleString([], {
                        month: "short", day: "numeric", hour: "2-digit", minute: "2-digit",
                      }) : ""}
                    </div>
                  </div>
                  <button
                    onClick={(e) => deleteSession(s.session_id, e)}
                    className="text-[#DC2626] shrink-0 p-1" title="Delete">
                    <Trash size={11} weight="bold" />
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  /* ── Main modal ──────────────────────────────────────────────────────────── */
  export default function AgentRunModal() {
    const { openAgent, setOpenAgent, setSetupOpen, profile, agents, launchAgent } = useErp();

    // TASK 3 — Route supplier-create to its own isolated modal.
    // All other agents continue using the existing AgentRunModal flow below.
    // This does NOT affect Receipt, Invoice, Finance, or any other agent.
    // if (openAgent === "supplier-create" || openAgent === "supplier-creation") {
    //   return <SupplierAgentModal />;
    // }

    const [messages, setMessages] = React.useState([]);
    // ── Copilot additions: progress + captured-fields tracking ──────────────
    const [copilotProgress, setCopilotProgress] = React.useState(null);       // e.g. "5/12 (42%)"
    const [copilotFields, setCopilotFields] = React.useState(null);           // data.fields_collected
    const isSupplierChat = openAgent === "supplier-creation" || openAgent === "supplier-create";
    const isChatOnly = openAgent === "supplier-ageing";
    
    // Fix 1: persist session ID so closing and reopening the modal resumes
    // the same conversation, rather than silently creating a brand-new session
    // and treating the user's first typed message as the Supplier Name.
    const sessionKey = isSupplierChat ? `supplier_session_id` : `agent_session_${openAgent}`;

    const [attaching, setAttaching] = React.useState(false);
    const [attachedCount, setAttachedCount] = React.useState(0);
    const [invoicePendingFiles, setInvoicePendingFiles] = React.useState([]);
    const [invoiceAttaching, setInvoiceAttaching] = React.useState(false);
    const pendingAttachmentModeRef = React.useRef(null);
    const [input, setInput] = React.useState("");
    const [busy, setBusy] = React.useState(false);
    const [validating, setValidating] = React.useState(false);
    const [chatStarted, setChatStarted] = React.useState(false);
    const [sessionId, setSessionId] = React.useState(() => crypto.randomUUID());
    // Agents that support persisted chat history (New Chat + history bar).
    const HISTORY_AGENTS = ["invoice-create", "supplier-creation", "purchase-req-create", "receipt-create", "supplier-ageing"];
    const supportsHistory = HISTORY_AGENTS.includes(openAgent);

    const [fieldValues, setFieldValues] = React.useState({});
    const [missingFields, setMissingFields] = React.useState([]);
    const [fieldErrors, setFieldErrors] = React.useState({});
    const [fieldWarnings, setFieldWarnings] = React.useState({});
    const [saved, setSaved] = React.useState([]);
    const [schedules, setSchedules] = React.useState([]);
    const [savedBusy, setSavedBusy] = React.useState(false);
    const [openSchedFor, setOpenSchedFor] = React.useState(null);
    const [schedForm, setSchedForm] = React.useState({
      cadence: "monthly", day_of_week: 0, day_of_month: 1, hour_utc: 8,
    });

    const [wizardSchemaFields, setWizardSchemaFields] = React.useState([]);
    const lastSentContextRef = React.useRef("");

    /* ── PO decision + invoice confirm state ── */
    const [showPOCard, setShowPOCard] = React.useState(false);
    const [poDecisionMade, setPoDecisionMade] = React.useState(false);
    const [showConfirmPopup, setShowConfirmPopup] = React.useState(false);
    const [pendingConfirmText, setPendingConfirmText] = React.useState("");

    /* ── Wizard direct-submit state (separate from chat state) ── */
    const [wizardBusy, setWizardBusy] = React.useState(false);
    const [wizardResult, setWizardResult] = React.useState(null);

    const agent = agents.find((a) => a.key === openAgent);
    const messagesEndRef = React.useRef(null);
    const inputRef = React.useRef(null);

    React.useEffect(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    // const ts = () => new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

    const loadSaved = React.useCallback(async (key) => {
      if (!key) return;
      try {
        const [{ data: sq }, { data: sch }] = await Promise.all([
          api.get(`/erp-agents/saved-queries?agent_key=${key}`),
          api.get(`/erp-agents/schedules`),
        ]);
        setSaved(sq || []);
        setSchedules(sch || []);
      } catch {
        setSaved([]);
        setSchedules([]);
      }
    }, []);

    const handleAttachFiles = async (files) => {
      setAttaching(true);
      const results = [];
      for (const file of files) {
        try {
          const formData = new FormData();
          formData.append("file", file);
          const { data } = await api.post(
            `/erp-agents/supplier-creation/${sessionId}/upload-attachment`,
            formData,
            { headers: { "Content-Type": "multipart/form-data" } }
          );
          setAttachedCount(data.attachments_count);
          results.push({ name: file.name, ok: true, count: data.attachments_count });
        } catch (e) {
          const msg = e?.response?.data?.detail || `Failed to upload ${file.name}`;
          results.push({ name: file.name, ok: false, error: msg });
        }
      }
      setAttaching(false);
      const succeeded = results.filter(r => r.ok).map(r => r.name);
      const failed = results.filter(r => !r.ok);
      let summary = "";
      if (succeeded.length) summary += `📎 Attached: ${succeeded.join(", ")}`;
      if (failed.length) summary += (summary ? "\n" : "") + failed.map(f => `❌ ${f.name}: ${f.error}`).join("\n");
      // Show inline confirmation
      setMessages((prev) => [...prev, {
        id: Date.now(), role: "assistant", timestamp: ts(), text: summary || "Upload complete.",
      }]);
      // Issue 1 FIX: if in the classification_attachments stage, re-send a
      // lightweight probe message so the backend re-renders the attachment_gate
      // UI with the updated file count — this makes the 'Done' button appear
      // automatically after a successful upload without requiring a page refresh.
      if (succeeded.length > 0) {
        // Small delay so the Redis save from the upload endpoint completes first
        setTimeout(() => sendMessage("__refresh_attachment_ui__"), 300);
      }
    };

    // Receipt-create: file upload handler for the paperclip button
    // const [receiptAttaching, setReceiptAttaching] = React.useState(false);
    // const [receiptAttachedName, setReceiptAttachedName] = React.useState(null);

    // const handleReceiptAttachFiles = async (files) => {
    //   const file = files[0];
    //   if (!file) return;
    //   setReceiptAttaching(true);
    //   setMessages((prev) => [...prev, { id: Date.now() + 1, role: 'assistant', loading: true }]);
    //   try {
    //     const formData = new FormData();
    //     formData.append('file', file);
    //     const { data } = await api.post(
    //       `/erp-agents/receipt-create/${sessionId}/upload-receipt-attachment`,
    //       formData,
    //       { headers: { 'Content-Type': 'multipart/form-data' } }
    //     );
    //     setReceiptAttachedName(file.name);
    //     const reply = data?.reply || data?.response || 'Receipt document uploaded.';
    //     if (data?.progress) setCopilotProgress(data.progress);
    //     if (data?.fields_collected) setCopilotFields(data.fields_collected);
    //     setMessages((prev) =>
    //       prev.map((m) => m.loading ? { ...m, loading: false, timestamp: ts(), text: reply, result: data } : m)
    //     );
    //   } catch (err) {
    //     const msg = err?.response?.data?.detail || err.message || 'Upload failed';
    //     setMessages((prev) => prev.map((m) => m.loading ? { ...m, loading: false, timestamp: ts(), text: '\u274c ' + msg } : m));
    //   } finally {
    //     setReceiptAttaching(false);
    //   }
    // };


    React.useEffect(() => {
      messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    // const loadSaved = React.useCallback(async (key) => {
    //   if (!key) return;
    //   try {
    //     const [{ data: sq }, { data: sch }] = await Promise.all([
    //       api.get(`/erp-agents/saved-queries?agent_key=${key}`),
    //       api.get(`/erp-agents/schedules`),
    //     ]);
    //     setSaved(sq || []);
    //     setSchedules(sch || []);
    //   } catch {
    //     setSaved([]);
    //     setSchedules([]);
    //   }
    // }, []);

    React.useEffect(() => {
      setMessages([]);
      setInput("");
      setBusy(false);
      setChatStarted(false);
      setFieldValues({});
      setMissingFields([]);
      setFieldErrors({});
      setFieldWarnings({});
      setOpenSchedFor(null);
      setShowPOCard(false);
      setPoDecisionMade(false);
      setShowConfirmPopup(false);
      setPendingConfirmText("");
      setWizardBusy(false);
      setWizardResult(null);
      setWizardSchemaFields([]);
      lastSentContextRef.current = "";
      if (openAgent) loadSaved(openAgent);
    }, [openAgent, loadSaved]);

    if (!openAgent) return null;
     if (openAgent === "invoice-ageing") return <InvoiceAgeingModal />;
     if (openAgent === "supplier-ageing") return <SupplierAgeingModal />;
     if (openAgent == "rfp-create") return  <RFPAgentModal />;

    const close = () => {
      setOpenAgent(null);
      setMessages([]);
      setFieldValues({});
      setChatStarted(false);
    };

    const payloadFV = () => {
    const out = {};
    for (const [k, v] of Object.entries(fieldValues)) {
      if (k.endsWith("__label")) continue; // internal display-only value, never sent to backend
      out[k] = Array.isArray(v) && v[0]?.attachment_id ? v.map((i) => i.attachment_id) : v;
    }
    return out;
  };

      // Issue 10 — converts raw browser File objects (from the Classification
    // Documents / Additional Attachments file pickers) into the
    // {file_name, content_type, base64_content, classification_code,
    // required_document} shape the backend expects. Classification docs are
    // tagged with their required-document label IN SELECTION ORDER, matching
    // the order the required-documents banner lists them — same convention
    // the chat flow's auto-association uses.
    const fileToBase64 = (file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });

    const buildAttachmentsPayload = async () => {
      const classificationFiles = fieldValues["classification_documents"] || [];
      const extraFiles = fieldValues["attachments"] || [];
      let classificationAttachmentMap = {};
      try {
        const { data } = await api.get(`/erp-agents/agent-fields/${openAgent}`);
        classificationAttachmentMap = data?.classification_attachment_map || {};
      } catch (e) {
        console.warn("[attachments] could not fetch classification_attachment_map, proceeding without auto-tagging", e);
      }
      const selectedClassifications = (fieldValues["business_classifications"] || [])
        .filter((c) => classificationAttachmentMap[c]);

      const attachments = [];
      for (let i = 0; i < classificationFiles.length; i++) {
        const file = classificationFiles[i];
        if (!(file instanceof File)) continue; // already-uploaded reference, skip
        const base64 = await fileToBase64(file);
        const code = selectedClassifications[i];
        attachments.push({
          file_name: file.name,
          content_type: file.type,
          base64_content: base64,
          classification_code: code || null,
          required_document: code ? classificationAttachmentMap[code] : null,
          category_name: code ? "Business Classifications" : "Miscellaneous",
          title: code ? classificationAttachmentMap[code] : file.name,
        });
      }
      for (const file of extraFiles) {
        if (!(file instanceof File)) continue;
        const base64 = await fileToBase64(file);
        attachments.push({
          file_name: file.name, content_type: file.type, base64_content: base64,
          classification_code: null, required_document: null,
          category_name: "Miscellaneous", title: file.name,
        });
      }
      return attachments;
    };
    /* ── invoice-create: encode File objects to the {file_name,mime_type,data} shape ── */
  const encodeInvoiceFiles = async (files) => {
    const encoded = [];
    for (const file of files) {
      const b64 = await fileToBase64(file);
      encoded.push({
        file_name: file.name,
        mime_type: file.type || "application/pdf",
        data: b64,
      });
    }
    return encoded;
  };

  /* End-of-flow attach widget: upload one OR MORE files (mode=attach), then
     tell the backend they were added via the sentinel the extractor understands.
     No processing — the files are attached to the Oracle invoice as-is. */
  const handleInvoiceWidgetUpload = async (fileList) => {
    setInvoiceAttaching(true);
    try {
      const encoded = await encodeInvoiceFiles(fileList);
      setInvoicePendingFiles(encoded);
      pendingAttachmentModeRef.current = "attach";
      setTimeout(() => sendMessage("__ATTACHMENT_ADDED__"), 50);
    } finally {
      setInvoiceAttaching(false);
    }
  };

  const handleInvoiceWidgetSkip = () => {
    sendMessage("__SKIP_ATTACHMENT__");
  };


    const ts = () => new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

    /* ── Dry-run validate ── */
    const dryRunValidate = async () => {
      setValidating(true);
      setFieldErrors({});
      setFieldWarnings({});
      if (!chatStarted) setChatStarted(true);
      try {
        const { data } = await api.post(`/erp-agents/${openAgent}/validate`, {
          field_values: payloadFV(),
        });
        setFieldErrors(data.field_errors || {});
        setFieldWarnings(data.field_warnings || {});
        setMessages((prev) => [
          ...prev,
          {
            id: Date.now(),
            role: "assistant",
            timestamp: ts(),
            text: data.ok
              ? "✅ Validation passed — all fields look good. Ready to send to Oracle."
              : `❌ ${Object.keys(data.field_errors || {}).length} error(s) found — check the highlighted fields in the wizard.`,
          },
        ]);
      } catch (e) {
        setFieldErrors({ _general: e?.response?.data?.detail || e.message });
      } finally {
        setValidating(false);
      }
    };

    /* ── Send message ──
     BUG FIX: invoice-create sends ONLY session_id + message, plus attachments
     + attachment_mode when files are staged this turn.
     All other agents send prompt + field_values as before.             */
  const sendMessage = async (text, forceRun = false) => {
    const rawText = (text || "").trim();
    if (!rawText || busy) return;
    const fullCtx = isChatOnlyAgent(openAgent) ? buildFieldContext(fieldValues, wizardSchemaFields) : "";
    // Only attach it if it's new/changed since the last message — otherwise
    // it would repeat on every send as long as the fields stay filled in.
    const ctx = fullCtx && fullCtx !== lastSentContextRef.current ? fullCtx : "";
    const userText = ctx ? `${ctx}. ${rawText}` : rawText;
    if (fullCtx) lastSentContextRef.current = fullCtx;

    setInput("");
    if (inputRef.current) inputRef.current.style.height = "auto";
    if (!chatStarted) setChatStarted(true);

    // Sentinel messages are internal — don't echo them as user chat bubbles.
    const isSentinel = [
      "__ATTACHMENT_ADDED__", "__SKIP_ATTACHMENT__",
      "__refresh_attachment_ui__",
    ].includes(rawText);

    const now = ts();
    setMessages((prev) => [
      ...prev,
      ...(isSentinel ? [] : [{ id: Date.now(), role: "user", text: userText, timestamp: now }]),
      { id: Date.now() + 1, role: "assistant", loading: true },
    ]);
    setBusy(true);
    setMissingFields([]);
    setFieldErrors({});
    setFieldWarnings({});

    try {
      let data;

      if (openAgent === "invoice-create") {
        /* ── invoice-create: chat endpoint — carries attachments when staged ── */
        const body = {
          session_id: sessionId,
          message: userText,
        };
        if (invoicePendingFiles.length) {
          body.attachments = invoicePendingFiles;
          body.attachment_mode = pendingAttachmentModeRef.current || null;
        }
        const res = await api.post("/erp-agents/invoice-create/chat", body);
        data = res.data;
        // Files were sent this turn; clear the stage so they aren't re-sent.
        if (invoicePendingFiles.length) setInvoicePendingFiles([]);
        pendingAttachmentModeRef.current = null;
      } else if (openAgent === "purchase-req-create") {
          /* ── purchase-req-create: dedicated PR agent chat endpoint ── */
          const res = await api.post("/erp-agents/purchase-req-create/chat", {
            session_id: sessionId,
            message: userText,
          });
          data = res.data;
        // } else if (openAgent === "receipt-create") {
        //   /* ── receipt-create: dedicated Receipt agent chat endpoint ── */
        //   const res = await api.post("/erp-agents/receipt-create/chat", {
        //     session_id: sessionId,
        //     message: userText,
        //   });
        //   data = res.data;
        //           if (data?.progress) setCopilotProgress(data.progress);
        //   if (data?.fields_collected) setCopilotFields(data.fields_collected);

        }
        else if (openAgent === "supplier-ageing") {
          /* ── supplier-ageing: dedicated Supplier Ageing agent chat endpoint ── */
          const res = await api.post("/erp-agents/supplier-ageing/chat", {
            session_id: sessionId,
            message: userText,
          });
          data = res.data;
                  if (data?.progress) setCopilotProgress(data.progress);
          if (data?.fields_collected) setCopilotFields(data.fields_collected);

        }
        else if (openAgent === "supplier-creation" || openAgent === "supplier-create") {
          /* ── supplier-creation: dedicated Supplier Creation agent chat endpoint ── */
          const res = await api.post("/erp-agents/supplier-creation/chat", {
            session_id: sessionId,
            message:    userText,
          });
          data = res.data;
        }
        else if (openAgent === "account-overview" ||
          openAgent === "finance-account-overview" ||
          openAgent?.includes("account-overview") ||
          openAgent?.includes("account_overview")) {
          const res = await api.post("/erp-agents/account-overview/chat", {
            session_id: sessionId,
            question: userText,
          });
          data = {
            status: "success",
            response: res.data?.answer || res.data?.response || JSON.stringify(res.data),
          };
        }
        else if (openAgent === "finance-variance" ||
          openAgent === "finance-account-variance" ||
          openAgent?.includes("finance-variance")) {
          const res = await api.post("/erp-agents/finance-variance/chat", {
            session_id: sessionId,
            question: userText,
          });
          data = {
            status: "success",
            response: res.data?.answer || res.data?.response || JSON.stringify(res.data),
          };
        }
        else if (
          openAgent === "finance-future-insight" ||
          openAgent === "future-insight" ||
          openAgent?.includes("finance-future")
        ) {
          /* ── account-overview: simple Q&A endpoint, no wizard / saved queries ── */
          const res = await api.post("/erp-agents/future-insights/chat", {
            session_id: sessionId,
            question: userText,
          });
          data = {
            status:   "success",
            response: res.data?.answer || res.data?.response || JSON.stringify(res.data),
          };
        }
        else if (
          openAgent === "finance-narrative" ||
          openAgent === "finance-reporting-narrative" ||
          openAgent?.includes("finance-narrative")
        ) {
          /* ── account-overview: simple Q&A endpoint, no wizard / saved queries ── */
          const res = await api.post("/erp-agents/finance-narrative/chat", {
            session_id: sessionId,
            question: userText,
          });
          data = {
            status:   "success",
            response: res.data?.answer || res.data?.response || JSON.stringify(res.data),
          };
        }
        else {
          /* ── all other agents: wizard run endpoint ── */
          const res = await api.post(`/erp-agents/${openAgent}/run`, {
            prompt: userText,
            field_values: payloadFV(),
            force_run: forceRun,
          });
          data = res.data;

          /* Only wizard agents sync parsed_payload back into form fields */
          if (data?.parsed_payload && typeof data.parsed_payload === "object")
            setFieldValues((prev) => ({ ...prev, ...data.parsed_payload }));
          if (data?.missing?.length)
            setMissingFields(data.missing);
        }

        /* Normalise status — backend may return UPPER or lower case */
        const status = (data?.status || "").toLowerCase();
        const backendMsg = data?.reply || data?.response || data?.message;

        // Copilot: track progress + captured fields for the sidebar UI
        if (data?.progress !== undefined) setCopilotProgress(data.progress);
              if (data?.fields_collected !== undefined) {
          setCopilotFields(data.fields_collected);
          // Chat→Wizard sync: merge chat-captured fields into wizard fieldValues.
          // The chat backend uses different key names for some fields:
          //   supplier_city    → city
          //   supplier_country → country
          //   supplier_state   → state
          //   address_line1    → address_line1  (same)
          //   address_name     → address_name   (same)
          //   procurement_bu   → procurement_bu (same)
          // All others map 1:1.
          if (isSupplierChat && data.fields_collected && typeof data.fields_collected === "object") {
            const CHAT_TO_WIZARD = {
              supplier_city:    "city",
              supplier_country: "country",
              supplier_state:   "state",
              supplier_site:    "supplier_site",
            };
            setFieldValues(prev => {
              const merged = { ...prev };
              for (const [chatKey, val] of Object.entries(data.fields_collected)) {
                if (val === null || val === undefined || val === "") continue;
                const wizardKey = CHAT_TO_WIZARD[chatKey] || chatKey;
                // procurement_bus is a list — wizard needs first element as string
                const wizardVal = (chatKey === "procurement_bus")
                  ? (Array.isArray(val) ? val[0] : val)
                  : val;
                if (wizardVal && !merged[wizardKey]) {
                  merged[wizardKey] = wizardVal;
                }
              }
              // procurement_bus list → procurement_bu wizard field
              // Only set if not already filled by the user in the wizard
              const buList = data.fields_collected.procurement_bus;
              if (buList && !prev.procurement_bu) {
                merged.procurement_bu = Array.isArray(buList) ? buList[0] : buList;
              }
              // procurement_bu scalar (set during the collecting_extra_bu flow)
              const buScalar = data.fields_collected.procurement_bu;
              if (buScalar && typeof buScalar === "string" && !prev.procurement_bu) {
                merged.procurement_bu = buScalar;
              }
              return merged;
            });
          }
        }
        const reply =
          ["ok", "success", "completed"].includes(status)
            ? backendMsg || `Done! ${agent?.label} submitted to Oracle successfully.`
            : ["needs_input", "validating_fields"].includes(status)
              ? backendMsg || "Please fill in the required fields."
              : ["awaiting_confirm", "awaiting_po_decision"].includes(status)
                ? backendMsg || "Please review and confirm the details."
                : status === "llm_error"
                  ? backendMsg || "I had trouble parsing that. Could you rephrase?"
                  : status === "oracle_error"
                    ? backendMsg || `Oracle returned an error (HTTP ${data?.http_status}).`
                    : status === "unconfigured"
                      ? backendMsg || "Oracle profile isn't set up. Click ⚙ to configure it."
                      : backendMsg || "Something unexpected happened.";

        const now2 = ts();
        setMessages((prev) =>
          prev.map((m) =>
            m.loading
              ? {
                ...m,
                loading: false,
                text: reply,
                result: data,
                timestamp: now2,
                onSave:
                  ["ok", "success"].includes(status) && data?.parsed_payload
                    ? () => saveQuery(data, userText)
                    : null,
              }
              : m
          )
        );

        /* ── PO card — detect from status OR from the agent's reply text ──
          The agent sometimes asks the PO question conversationally without
          the status changing to AWAITING_PO_DECISION (e.g. after Oracle
          validates the supplier). We catch both cases here.             */
        const replyLower = (reply || "").toLowerCase();
        const isPOQuestion = (
          status === "awaiting_po_decision"
          || replyLower.includes("do you have a po number")
          || replyLower.includes("do you have a purchase order")
          || replyLower.includes("po number for this invoice")
          || replyLower.includes("provide a po number")
          || replyLower.includes("standalone invoice")
          || (replyLower.includes("po") && replyLower.includes("standalone"))
        );

        if (isPOQuestion && !poDecisionMade) {
          setShowPOCard(true);
        }

        /* ── Confirm popup — detect from status OR reply text ── */
        const isConfirmQuestion = (
          status === "awaiting_confirm"
          || (replyLower.includes("reply confirm") && replyLower.includes("oracle"))
          || (replyLower.includes("confirm") && replyLower.includes("create this in oracle"))
          || (replyLower.includes("confirm to create"))
        );

        if (isConfirmQuestion && !isSupplierChat && !["ok", "success", "completed", "failed"].includes(status)) {
          setPendingConfirmText(reply);
          setShowConfirmPopup(true);
        }

        await loadSaved(openAgent);
      } catch (e) {
        setMessages((prev) =>
          prev.map((m) =>
            m.loading
              ? { ...m, loading: false, timestamp: ts(), text: `Error: ${e?.response?.data?.detail || e.message}` }
              : m
          )
        );
      } finally {
        setBusy(false);
        setTimeout(() => inputRef.current?.focus(), 100);
      }
    };

    /* ── Save query ── */
    const saveQuery = async (result, prompt) => {
      const label = window.prompt(
        "Name this saved query:",
        `${agent?.label} · ${new Date().toISOString().slice(0, 10)}`
      );
      if (!label) return;
      setSavedBusy(true);
      try {
        await api.post(`/erp-agents/saved-queries`, {
          agent_key: openAgent,
          label: label.trim(),
          prompt,
          parsed_payload: result.parsed_payload,
        });
        await loadSaved(openAgent);
        setMessages((prev) => [
          ...prev,
          { id: Date.now(), role: "assistant", timestamp: ts(), text: `Saved as "${label.trim()}".` },
        ]);
      } catch (e) {
        window.alert(`Save failed: ${e?.response?.data?.detail || e.message}`);
      } finally {
        setSavedBusy(false);
      }
    };

    /* ── Replay ── */
    const replay = async (sid) => {
      setBusy(true);
      if (!chatStarted) setChatStarted(true);
      setMessages((prev) => [
        ...prev,
        { id: Date.now() - 1, role: "user", text: "↩ Replaying saved query…", timestamp: ts() },
        { id: Date.now(), role: "assistant", loading: true },
      ]);
      try {
        const { data } = await api.post(`/erp-agents/saved-queries/${sid}/replay`);
        setMessages((prev) =>
          prev.map((m) =>
            m.loading
              ? {
                ...m,
                loading: false,
                result: data,
                timestamp: ts(),
                text: data?.status === "ok" ? "Replayed successfully!" : `Replay error: ${data?.status}`,
              }
              : m
          )
        );
        await loadSaved(openAgent);
      } catch (e) {
        setMessages((prev) =>
          prev.map((m) =>
            m.loading ? { ...m, loading: false, timestamp: ts(), text: `Replay failed: ${e.message}` } : m
          )
        );
      } finally {
        setBusy(false);
      }
    };

    const removeSaved = async (sid) => {
      if (!window.confirm("Delete?")) return;
      try {
        await api.delete(`/erp-agents/saved-queries/${sid}`);
        await loadSaved(openAgent);
      } catch (e) { window.alert(e?.response?.data?.detail || e.message); }
    };

    const createSchedule = async (sqid) => {
      try {
        await api.post(`/erp-agents/schedules`, { saved_query_id: sqid, ...schedForm });
        setOpenSchedFor(null);
        setSchedForm({ cadence: "monthly", day_of_week: 0, day_of_month: 1, hour_utc: 8 });
        await loadSaved(openAgent);
      } catch (e) { window.alert(e?.response?.data?.detail || e.message); }
    };

    const toggleSchedule = async (id) => {
      try {
        await api.post(`/erp-agents/schedules/${id}/toggle`);
        await loadSaved(openAgent);
      } catch (e) { window.alert(e?.response?.data?.detail || e.message); }
    };

    const deleteSchedule = async (id) => {
      if (!window.confirm("Delete schedule?")) return;
      try {
        await api.delete(`/erp-agents/schedules/${id}`);
        await loadSaved(openAgent);
      } catch (e) { window.alert(e?.response?.data?.detail || e.message); }
    };

    const schedsFor = (sid) => schedules.filter((s) => s.saved_query_id === sid);

    /* ── Wizard direct submit — bypasses LangGraph / AI agent entirely ──────
      The "Send to Oracle Fusion" buttons in the wizard panel call this,
      NOT sendMessage. Goes straight to /{openAgent}/manual.
      FIX: was hardcoded to /invoice-create/manual for EVERY agent — this
      meant clicking "Send to Oracle Fusion" on the Supplier wizard silently
      posted supplier field values to the invoice endpoint, which either
      422'd (wrong schema) or behaved unpredictably. Now routes per-agent. */
    const submitWizard = async (forceRun = false) => {
      setWizardBusy(true);
      setWizardResult(null);
      setFieldErrors({});
      setFieldWarnings({});
      try {
        const { data } = await api.post(`/erp-agents/${openAgent}/manual`, payloadFV());
        if (openAgent === "supplier-create") {
          body.attachments = await buildAttachmentsPayload();
          delete body.classification_documents; // sent via body.attachments instead, not as raw Files
        }
        data = await api.post(`/erp-agents/${openAgent}/manual`, body);
        setWizardResult(data);
        if (data?.field_errors) setFieldErrors(data.field_errors);
        if (data?.field_warnings) setFieldWarnings(data.field_warnings);
      } catch (e) {
        // FastAPI/Pydantic validation errors come back as an array of objects:
        // [{type, loc, msg, input}] — these cannot be rendered as React children.
        // Stringify them into a readable message before storing in state.
        const rawDetail = e?.response?.data?.detail;
        let detail;
        if (Array.isArray(rawDetail)) {
          // Pydantic v2 validation error array → extract human-readable messages
          detail = rawDetail
            .map((err) => {
              const field = Array.isArray(err.loc) ? err.loc.join(" → ") : String(err.loc || "");
              return field ? `${field}: ${err.msg}` : err.msg;
            })
            .join(" · ");
        } else if (rawDetail && typeof rawDetail === "object") {
          detail = JSON.stringify(rawDetail);
        } else {
          detail = rawDetail || e.message || "Unknown error";
        }
        setWizardResult({ status: "error", message: detail });
        setFieldErrors({ _general: detail });
      } finally {
        setWizardBusy(false);
      }
    };

    /* ── PO decision handlers ── */
    const handlePOYes = (poNum) => {
      setShowPOCard(false);
      setPoDecisionMade(true);
      sendMessage(`PO number: ${poNum}`);
    };

    const handlePOSkip = () => {
      setShowPOCard(false);
      setPoDecisionMade(true);
      sendMessage("No PO — create as standalone invoice");
    };

    /* ── Invoice confirm handlers ── */
    const handleConfirmInvoice = () => {
      setShowConfirmPopup(false);
      sendMessage("yes");
    };

    const handleCancelInvoice = () => {
      setShowConfirmPopup(false);
      const cancelText = openAgent === "supplier-create"
        ? "Supplier creation cancelled. Let me know if you'd like to make any changes."
        : "Invoice creation cancelled. Let me know if you'd like to make any changes.";
      setMessages((prev) => [
        ...prev,
        { id: Date.now(), role: "assistant", timestamp: ts(), text: cancelText },
      ]);
    };

    const handleInputChange = (e) => {
      setInput(e.target.value);
      e.target.style.height = "auto";
      e.target.style.height = Math.min(e.target.scrollHeight, 120) + "px";
    };

    /* ── Chat history: start fresh vs open a past conversation ── */
    const startNewChat = async () => {
      let newId = crypto.randomUUID();
      try {
        const { data } = await api.post(`/erp-agents/${openAgent}/sessions/new`);
        if (data?.session_id) newId = data.session_id;
      } catch { /* fall back to the local uuid */ }
      setSessionId(newId);
      setMessages([]);
      setInput("");
      setChatStarted(false);
      setShowPOCard(false);
      setPoDecisionMade(false);
      setShowConfirmPopup(false);
      setPendingConfirmText("");
      setFieldValues({});
    };

    const openSession = async (sid) => {
      try {
        const { data } = await api.get(`/erp-agents/${openAgent}/sessions/${sid}/messages`);
        const loaded = (data?.messages || []).map((m, i) => ({
          id: Date.now() + i,
          role: m.role,
          text: m.content,
          timestamp: m.created_at
            ? new Date(m.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
            : ts(),
          // Re-attach any widget from that turn so it renders again.
          result: m.next_field_ui ? { next_field_ui: m.next_field_ui } : undefined,
        }));
        setSessionId(sid);
        setMessages(loaded);
        setChatStarted(true);
        setPoDecisionMade(true);     // don't re-pop the PO card on a resumed chat
        setShowPOCard(false);
        setShowConfirmPopup(false);
      } catch (e) {
        window.alert(`Could not open conversation: ${e?.response?.data?.detail || e.message}`);
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); sendMessage(input); }
    };

    const savedProps = {
      saved, schedsFor, busy, openSchedFor, setOpenSchedFor,
      schedForm, setSchedForm, replay, removeSaved, createSchedule, toggleSchedule, deleteSchedule,
    };

    const isChatOnlyWizard = isChatOnlyAgent(openAgent); 
    /* ─────────────────────────────────────────────────────────────────────────
      RENDER — identical layout to original
    ───────────────────────────────────────────────────────────────────────── */
    return (
      <>
        <style>{`
          @keyframes chatFadeIn    { from { opacity:0; transform:translateX(-10px); } to { opacity:1; transform:translateX(0); } }
          @keyframes wizardSlideIn { from { opacity:0; transform:translateX(20px);  } to { opacity:1; transform:translateX(0); } }
          .modal-pre  { width:672px; max-width:calc(100vw - 2rem); max-height:90vh; }
          .modal-chat {
            width:min(74vw,1120px); height:78vh;
            resize: both; overflow: auto;
            min-width: 640px;  min-height: 460px;
            max-width: 96vw;   max-height: 94vh;
          }
          .modal-chat-wide { width:min(96vw,1600px); height:95vh; }
          /* Bigger, visible drag handle in the bottom-right corner (chat mode). */
          .modal-chat::-webkit-resizer { display: none; }
          .modal-resize-hint {
            position: absolute; right: 3px; bottom: 3px; width: 14px; height: 14px;
            cursor: nwse-resize; pointer-events: none; opacity: 0.5;
          }
        `}</style>

        <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4" onClick={() => { if (!chatStarted) close(); }}>
          <div
            onClick={(e) => e.stopPropagation()}
            data-testid={`agent-modal-${openAgent}`}
            className={`relative bg-white text-gray-900 border border-gray-300 flex flex-col
              ${chatStarted ? (isChatOnlyWizard ? "modal-chat-wide" : "modal-chat") : "modal-pre overflow-hidden"}`}
            style={{ transition: chatStarted ? "none" : "width 0.45s cubic-bezier(0.4,0,0.2,1), height 0.45s cubic-bezier(0.4,0,0.2,1)" }}
          >
            {chatStarted && (
              <svg className="modal-resize-hint" viewBox="0 0 14 14" fill="none">
                <path d="M13 5 L5 13 M13 9 L9 13 M13 1 L1 13" stroke="#9CA3AF" strokeWidth="1.2" />
              </svg>
            )}
            {/* ── Header ── */}
            <div className="px-5 py-4 border-b border-gray-200 flex items-start justify-between shrink-0">
              <div>
                <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-gray-500">
                  Oracle Fusion ERP · Vaku AI
                </div>
                <h3 className="text-2xl font-black tracking-tight mt-0.5">{agent?.label}</h3>
                <p className="text-xs text-gray-500 mt-0.5">{agent?.hint}</p>
              </div>
              <div className="flex items-center gap-3 shrink-0">
                {/* Chat controls — only for history agents, and only once a
                    conversation has started (hidden in the compact pre-chat modal). */}
                {supportsHistory && chatStarted && (
                  <>
                    <ChatHistoryControl
                      agentKey={openAgent}
                      currentSessionId={sessionId}
                      onNewChat={startNewChat}
                      onOpenSession={openSession}
                    />
                    <div className="w-px h-5 bg-gray-200" />
                  </>
                )}
                <button
                  onClick={() => { close(); setSetupOpen(true); }}
                  data-testid="agent-open-profile"
                  className="text-[11px] font-semibold text-gray-500 hover:text-[#0020C2] flex items-center gap-1">
                  <Gear size={13} weight="bold" /> {profile?.oracle_username || "Set up profile"}
                </button>
                <button onClick={close} data-testid="agent-modal-close">
                  <X size={18} />
                </button>
              </div>
            </div>

            {/* ── Body ── */}
            {!chatStarted ? (

              /* PRE-CHAT — compact modal, wizard + input + buttons */
              <>
                <div className="flex-1 overflow-y-auto p-5 space-y-4">
                  <SavedQueries {...savedProps} />
                  {!isChatOnly && (
                    <WizardFields
                      agentKey={openAgent}
                      values={fieldValues}
                      onChange={setFieldValues}
                      missingFields={missingFields}
                      onCreateNew={(key) => { close(); setTimeout(() => launchAgent(key), 100); }}
                      fieldErrors={fieldErrors}
                      fieldWarnings={fieldWarnings}
                      onSchemaLoad={setWizardSchemaFields}
                    />
                  )}

                  {/* Wizard result banner */}
                  {wizardResult && (
                    <div className={`border px-3 py-2 text-xs flex items-start gap-2
                      ${["ok", "success"].includes((wizardResult.status || "").toLowerCase())
                        ? "border-emerald-300 bg-emerald-50 text-emerald-800"
                        : "border-[#DC2626] bg-red-50 text-[#DC2626]"}`}>
                      {["ok", "success"].includes((wizardResult.status || "").toLowerCase())
                        ? <CheckCircle size={13} weight="fill" className="mt-0.5 shrink-0" />
                        : <WarningCircle size={13} weight="fill" className="mt-0.5 shrink-0" />}
                      <span className="font-bold">
                        {typeof wizardResult.message === "string"
                          ? wizardResult.message
                          : JSON.stringify(wizardResult.message)}
                      </span>
                      {wizardResult.invoice_number && (
                        <span className="font-mono ml-1 opacity-70">#{wizardResult.invoice_number}</span>
                      )}
                    </div>
                  )}

                  {Object.keys(fieldErrors).length > 0 && (
                    <div className="border border-[#DC2626] bg-red-50 px-3 py-2 text-xs text-[#DC2626] flex items-start gap-2">
                      <WarningCircle size={13} weight="fill" className="mt-0.5 shrink-0" />
                      <span className="font-bold">
                        {Object.keys(fieldErrors).length} error(s) above — fix or submit anyway.
                      </span>
                    </div>
                  )}
                </div>

                              {/* Chat input — only shown in pre-chat to START a conversation.
                    Typing here and pressing send begins the AI chat flow.
                    The wizard "Send to Oracle Fusion" button is separate below. */}
                <div className="border-t border-gray-200 px-4 py-2 bg-white shrink-0">
                  <div className="flex items-center gap-2 text-xs text-gray-400">
                    <Robot size={12} weight="bold" />
                    <span>Or type a message below to use AI chat instead of the wizard</span>
                  </div>
                </div>

                <InputBar
                  inputRef={inputRef}
                  value={input}
                  onChange={handleInputChange}
                  onKeyDown={handleKeyDown}
                  onSend={() => sendMessage(input)}
                  busy={busy}
                  placeholder={agent?.hint || "Type a message to chat with AI…"}
                />

                <div className="shrink-0 border-t border-gray-200 px-5 py-3 bg-gray-50 flex flex-wrap gap-2" style={{ display: (isChatOnly || isChatOnlyWizard) ? "none" : undefined }}>
                  <button
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); submitWizard(false); }}
                    disabled={wizardBusy}
                    data-testid="agent-run"
                    className="bg-[#0020C2] text-white px-4 py-2.5 text-xs font-bold uppercase tracking-wider
                      hover:bg-[#001AA3] disabled:opacity-50 flex items-center gap-2">
                    {wizardBusy
                      ? <span className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                      : <PaperPlaneRight size={13} weight="fill" />}
                    {wizardBusy ? "Sending…" : "Send to Oracle Fusion"}
                  </button>
                  <button
                    onClick={(e) => { e.preventDefault(); e.stopPropagation(); dryRunValidate(); }}
                    disabled={wizardBusy || validating}
                    data-testid="agent-validate"
                    className="border border-[#0020C2] text-[#0020C2] hover:bg-[#0020C2] hover:text-white
                      px-4 py-2.5 text-xs font-bold uppercase tracking-wider disabled:opacity-50">
                    {validating ? "Validating…" : "Dry-run validate"}
                  </button>
                  {Object.keys(fieldErrors).length > 0 && (
                    <button
                      onClick={(e) => { e.preventDefault(); e.stopPropagation(); submitWizard(true); }}
                      disabled={wizardBusy}
                      data-testid="agent-submit-anyway"
                      className="border border-[#DC2626] text-[#DC2626] hover:bg-red-50
                        px-4 py-2.5 text-xs font-bold uppercase tracking-wider disabled:opacity-50">
                      Submit anyway
                    </button>
                  )}
                </div>
              </>

            ) : (

              /* CHAT MODE — 60% chat left / 40% wizard right */
              <div className="flex flex-1 overflow-hidden">

                {/* LEFT — chat 60% (100% for chat-only agents like supplier-ageing) */}
              <div
                className={`flex flex-col overflow-hidden ${isChatOnly ? "" : "border-r border-gray-200"}`}
                style={{ width: isChatOnly ? "100%" : "60%", animation: "chatFadeIn 0.4s cubic-bezier(0.4,0,0.2,1)" }}>
                {isSupplierChat && <ProgressBar progress={copilotProgress} />}
                {isSupplierChat && <CapturedFieldsPanel fields={copilotFields} />}
                {isSupplierChat && messages.length <= 1 && (
                  <QuickActions onPick={(text) => sendMessage(text)} />
                )}
                <div className="flex-1 overflow-y-auto px-4 py-4 space-y-3 bg-gray-50">
                  {messages.map((msg) => (
                    <ChatBubble
                      key={msg.id}
                      msg={msg}
                      sessionId={sessionId}
                      onOptionClick={(opt) => sendMessage(opt.value)}
                      onMultiSubmit={(values) => sendMessage(values.join(", "))}
                      isSupplierChat={isSupplierChat}
                      onInvoiceAttach={handleInvoiceWidgetUpload}
                      onInvoiceSkipAttach={handleInvoiceWidgetSkip}
                    />
                  ))}

                    {/* PO decision card — appears inline after the last AI message */}
                    {showPOCard && !poDecisionMade && (
                      <PODecisionCard onYes={handlePOYes} onSkip={handlePOSkip} />
                    )}

                    <div ref={messagesEndRef} />
                  </div>
                  <InputBar
                    inputRef={inputRef}
                    value={input}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}
                    onSend={() => sendMessage(input)}
                    busy={busy}
                    placeholder="Continue the conversation…"
                                      onAttach={isSupplierChat ? handleAttachFiles : undefined}
  attaching={isSupplierChat ? attaching : false}
  attachedCount={isSupplierChat ? attachedCount : 0}
                  />
                </div>

                {/* RIGHT — wizard 40% (hidden for chat-only agents) */}
                {!isChatOnly && (
                <div
                  className="flex flex-col bg-white"
                  style={{ width: "40%", minWidth: "360px", animation: "wizardSlideIn 0.45s cubic-bezier(0.4,0,0.2,1)" }}>

                  <div className="flex-1 overflow-y-auto p-4 space-y-4">
                    <div className="text-[10px] tracking-[0.2em] uppercase font-bold text-[#0020C2] flex items-center gap-1.5">
                      <Sparkle size={11} weight="fill" /> Wizard fields
                      <span className="text-gray-400 normal-case font-normal tracking-normal ml-1">
                        · auto-filled as you chat
                      </span>
                    </div>

                    <SavedQueries {...savedProps} />

                      <WizardFields
                        agentKey={openAgent}
                        values={fieldValues}
                        onChange={setFieldValues}
                        missingFields={missingFields}
                        onCreateNew={(key) => { close(); setTimeout(() => launchAgent(key), 100); }}
                        fieldErrors={fieldErrors}
                        fieldWarnings={fieldWarnings}
                        onSchemaLoad={setWizardSchemaFields}
                      />

                    {Object.keys(fieldErrors).length > 0 && (
                      <div className="border border-[#DC2626] bg-red-50 px-3 py-2 text-xs text-[#DC2626] flex items-start gap-2">
                        <WarningCircle size={13} weight="fill" className="mt-0.5 shrink-0" />
                        <span className="font-bold">
                          {Object.keys(fieldErrors).length} error(s) — fix above.
                        </span>
                      </div>
                    )}
                  </div>

                    {/* Buttons pinned to bottom — hidden entirely for our chat-only wizard agents */}
                    {!isChatOnlyWizard && (
                      <div className="shrink-0 border-t border-gray-200 p-4 space-y-2 bg-white">

                        {/* Wizard result banner in chat mode */}
                        {wizardResult && (
                          <div className={`border px-3 py-2 text-xs flex items-start gap-2 rounded
                            ${["ok", "success"].includes((wizardResult.status || "").toLowerCase())
                              ? "border-emerald-300 bg-emerald-50 text-emerald-800"
                              : "border-[#DC2626] bg-red-50 text-[#DC2626]"}`}>
                            {["ok", "success"].includes((wizardResult.status || "").toLowerCase())
                              ? <CheckCircle size={12} weight="fill" className="mt-0.5 shrink-0" />
                              : <WarningCircle size={12} weight="fill" className="mt-0.5 shrink-0" />}
                            <span className="font-bold text-[11px]">
                              {typeof wizardResult.message === "string"
                                ? wizardResult.message
                                : JSON.stringify(wizardResult.message)}
                            </span>
                            {wizardResult.invoice_number && (
                              <span className="font-mono ml-1 opacity-70 text-[10px]">#{wizardResult.invoice_number}</span>
                            )}
                          </div>
                        )}

                        <button
                          onClick={() => submitWizard(false)}
                          disabled={wizardBusy}
                          data-testid="agent-run"
                          className="w-full bg-[#0020C2] text-white px-4 py-3 text-xs font-bold uppercase tracking-wider
                            hover:bg-[#001AA3] disabled:opacity-50 flex items-center justify-center gap-2">
                          {wizardBusy
                            ? <span className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                            : <PaperPlaneRight size={13} weight="fill" />}
                          {wizardBusy ? "Sending…" : "Send to Oracle Fusion"}
                        </button>
                        <button
                          onClick={dryRunValidate}
                          disabled={wizardBusy || validating}
                          data-testid="agent-validate"
                          className="w-full border border-[#0020C2] text-[#0020C2] hover:bg-[#0020C2] hover:text-white
                            px-4 py-2.5 text-xs font-bold uppercase tracking-wider disabled:opacity-50
                            flex items-center justify-center gap-2">
                          {validating ? "Validating…" : "Dry-run validate"}
                        </button>
                        {Object.keys(fieldErrors).length > 0 && (
                          <button
                            onClick={() => submitWizard(true)}
                            disabled={wizardBusy}
                            data-testid="agent-submit-anyway"
                            className="w-full border border-[#DC2626] text-[#DC2626] hover:bg-red-50
                              px-4 py-2.5 text-xs font-bold uppercase tracking-wider disabled:opacity-50
                              flex items-center justify-center">
                            Submit anyway
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* Invoice confirm popup — rendered outside the modal scroll so it overlays everything */}
        {showConfirmPopup && (
          <ConfirmReviewPopup
            title={openAgent === "supplier-create" ? "Review Supplier" : "Review Invoice"}
            subtitle={openAgent === "supplier-create"
              ? "Confirm all supplier details before creating in Oracle Fusion"
              : "Confirm all details before creating in Oracle Fusion"}
            fields={extractInvoiceFields(pendingConfirmText)}
            confirmLabel={openAgent === "supplier-create" ? "Create Supplier" : "Create Invoice"}
            onConfirm={handleConfirmInvoice}
            onCancel={handleCancelInvoice}
            busy={busy}
          />
        )}
      </>
    );
  }